webpackJsonp([4],{

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(114);

var _NewFooterV = __webpack_require__(544);

var _NewFooterV2 = _interopRequireDefault(_NewFooterV);

var _NewMenu = __webpack_require__(551);

var _NewMenu2 = _interopRequireDefault(_NewMenu);

var _DemoForm = __webpack_require__(542);

var _DemoForm2 = _interopRequireDefault(_DemoForm);

var _CallToActionSection = __webpack_require__(619);

var _CallToActionSection2 = _interopRequireDefault(_CallToActionSection);

var _TestimonialsVideoCardsV = __webpack_require__(631);

var _TestimonialsVideoCardsV2 = _interopRequireDefault(_TestimonialsVideoCardsV);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _UnifiedFAQ = __webpack_require__(563);

var _UnifiedFAQ2 = _interopRequireDefault(_UnifiedFAQ);

var _SimpleAccordionContainer = __webpack_require__(627);

var _SimpleAccordionContainer2 = _interopRequireDefault(_SimpleAccordionContainer);

var _SimpleAccordionItem = __webpack_require__(604);

var _SimpleAccordionItem2 = _interopRequireDefault(_SimpleAccordionItem);

var _TwoColsV = __webpack_require__(596);

var _TwoColsV2 = _interopRequireDefault(_TwoColsV);

var _SmoothDragScroll = __webpack_require__(632);

var _SmoothDragScroll2 = _interopRequireDefault(_SmoothDragScroll);

var _FinalCTACard = __webpack_require__(569);

var _FinalCTACard2 = _interopRequireDefault(_FinalCTACard);

__webpack_require__(647);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IndustrySystemv2 = function (_Component) {
  _inherits(IndustrySystemv2, _Component);

  function IndustrySystemv2(props) {
    _classCallCheck(this, IndustrySystemv2);

    var _this = _possibleConstructorReturn(this, (IndustrySystemv2.__proto__ || Object.getPrototypeOf(IndustrySystemv2)).call(this, props));

    _this.accordionImages = [{
      src: "/images/site/landing-pages/forca-vendas/conectado.png",
      alt: "Imagem trazendo logos de empresas as quais o sistema para indústria Mercos se integra. São elas: Power BI, Tiny, Totvs, Omie, Conta Azul, Sankhya, Bling, RD Station, SAP, Zucchetti e Cigam"
    }, {
      src: "/images/site/landing-pages/industrias/solucoes.png",
      alt: "Interface de pedidos com inteligência artificial do Mercos para automatizar vendas"
    }, {
      src: "/images/site/landing-pages/industrias/captacao.png",
      alt: "Dashboard com relatórios de vendas detalhados no sistema Mercos"
    }];

    _this.handleResourcesScroll = function (direction) {
      var scrollAmount = 280;
      var sliderElement = _this.resourcesSliderRef.current.slider.current;

      if (direction === 'left') {
        sliderElement.scroll({ left: sliderElement.scrollLeft - scrollAmount, behavior: 'smooth' });
      } else {
        sliderElement.scroll({ left: sliderElement.scrollLeft + scrollAmount, behavior: 'smooth' });
      }
    };

    _this.checkScrollPosition = function () {
      if (_this.resourcesSliderRef.current && _this.resourcesSliderRef.current.slider.current) {
        var sliderElement = _this.resourcesSliderRef.current.slider.current;
        var scrollLeft = sliderElement.scrollLeft,
            scrollWidth = sliderElement.scrollWidth,
            clientWidth = sliderElement.clientWidth;

        _this.setState({
          canScrollLeft: scrollLeft > 0,
          canScrollRight: scrollLeft < scrollWidth - clientWidth - 1
        });
      }
    };

    _this.handleAccordionClick = function (index) {
      _this.setState({
        activeAccordion: index
      });
    };

    _this.resourcesSliderRef = _react2.default.createRef();
    _this.state = {
      canScrollLeft: false,
      canScrollRight: false,
      activeAccordion: 0 // Default to first accordion item
    };
    return _this;
  }

  _createClass(IndustrySystemv2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.resourcesSliderRef.current && this.resourcesSliderRef.current.slider.current) {
        var sliderElement = this.resourcesSliderRef.current.slider.current;
        this.checkScrollPosition();
        sliderElement.addEventListener('scroll', this.checkScrollPosition);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.resourcesSliderRef.current && this.resourcesSliderRef.current.slider.current) {
        var sliderElement = this.resourcesSliderRef.current.slider.current;
        sliderElement.removeEventListener('scroll', this.checkScrollPosition);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _react.Fragment,
        null,
        this.props.headData && _react2.default.createElement(
          _reactStatic.Head,
          null,
          _react2.default.createElement(
            "title",
            null,
            this.props.headData.pageTitle
          ),
          _react2.default.createElement("meta", { property: "og:title", content: this.props.headData.pageTitle }),
          _react2.default.createElement("meta", { name: "twitter:title", content: this.props.headData.pageTitle }),
          _react2.default.createElement("meta", { name: "description", content: this.props.headData.pageDescription }),
          _react2.default.createElement("meta", { property: "og:description", content: this.props.headData.pageDescription }),
          _react2.default.createElement("meta", { name: "twitter:description", content: this.props.headData.pageDescription }),
          _react2.default.createElement("meta", { property: "og:image", content: this.props.headData.ogImage }),
          _react2.default.createElement("meta", { name: "twitter:image", content: this.props.headData.ogImage }),
          _react2.default.createElement("meta", { property: "og:url", content: this.props.headData.ogUrl }),
          _react2.default.createElement("link", { rel: "canonical", href: this.props.headData.ogUrl }),
          _react2.default.createElement(
            "script",
            { type: "application/ld+json" },
            "{\n                            \"@context\": \"https://schema.org\",\n                            \"@type\": \"ImageObject\",\n                            \"contentUrl\": \"https://mercos.com/images/sistema-de-forca-de-vendas.png\",\n                            \"url\": \"https://mercos.com/images/sistema-de-forca-de-vendas.png\",\n                            \"name\": \"Sistema de For\xE7a de Vendas\",\n                            \"description\": \"A imagem mostra alguns dos indicadores do sistema de for\xE7a de vendas Mercos sendo eles Evolu\xE7\xE3o de Venda, Carteira de Clientes (que cont\xE9m um gr\xE1fico de pizza com Clientes Ativos, Inativos antigos e Recentes e Prospects), E-commerce B2B, valor vendido no m\xEAs, situa\xE7\xE3o do cliente nos \xFAltimos 6 meses, Pedidos e Atendimentos\",\n                            \"thumbnail\": {\n                                \"@type\": \"ImageObject\",\n                                \"contentUrl\": \"https://mercos.com/images/sistema-de-forca-de-vendas.png\"\n                            },\n                            \"width\": 809,\n                            \"height\": 656,\n                            \"uploadDate\": \"2025-08-22\",\n                            \"license\": \"https://mercos.com/\",\n                            \"author\": {\n                                \"@type\": \"Organization\",\n                                \"name\": \"Mercos\",\n                                \"url\": \"https://www.mercos.com\"\n                            },\n                            \"copyrightHolder\": {\n                                \"@type\": \"Organization\",\n                                \"name\": \"Mercos\"\n                            }\n                        }"
          ),
          _react2.default.createElement(
            "script",
            { type: "application/ld+json" },
            "{\n                            \"@context\": \"https://schema.org\",\n                            \"@type\": \"FAQPage\",\n                            \"mainEntity\": [\n                                {\n                                    \"@type\": \"Question\",\n                                    \"name\": \"O que \xE9 o sistema para ind\xFAstria Mercos?\",\n                                    \"acceptedAnswer\": {\n                                        \"@type\": \"Answer\",\n                                        \"text\": \"O Mercos \xE9 um sistema para ind\xFAstria que elimina retrabalhos e erros na gest\xE3o de pedidos, automatizando o processo comercial, integrando-se a ERPs e a outros sistemas das ind\xFAstrias.\\n\\nCom e-commerce B2B, intelig\xEAncia artificial e aplicativo mobile (que funciona inclusive offline), permite que representantes e equipes internas emitam pedidos de qualquer lugar, garantindo mais controle, visibilidade e dados confi\xE1veis para decis\xF5es estrat\xE9gicas.\"\n                                    }\n                                },\n                                {\n                                    \"@type\": \"Question\",\n                                    \"name\": \"Quais setores podem usar um sistema para ind\xFAstria como o Mercos?\",\n                                    \"acceptedAnswer\": {\n                                        \"@type\": \"Answer\",\n                                        \"text\": \"O Mercos atende diferentes setores que trabalham no modelo B2B no segmento de bens de consumo, como ind\xFAstrias de alimentos e bebidas, higiene e limpeza, cosm\xE9ticos, materiais de constru\xE7\xE3o, moda e confec\xE7\xE3o, autope\xE7as e muitas outras.\\n\\nQualquer empresa industrial que venda para outras empresas e tenha equipes de vendas pode se beneficiar de um sistema para ind\xFAstria como o Mercos, ganhando agilidade nos pedidos e integra\xE7\xE3o total com o restante da opera\xE7\xE3o.\"\n                                    }\n                                },\n                                {\n                                    \"@type\": \"Question\",\n                                    \"name\": \"O Mercos \xE9 indicado para minha ind\xFAstria?\",\n                                    \"acceptedAnswer\": {\n                                        \"@type\": \"Answer\",\n                                        \"text\": \"Sim, o Mercos \xE9 um sistema para ind\xFAstria indicado para gestores que desejam otimizar a gest\xE3o comercial e o processo de pedidos B2B. Ele potencializa as vendas ao disponibilizar uma ferramenta pr\xE1tica para representantes e vendedores internos, facilita o acompanhamento de resultados e garante uma vis\xE3o completa da opera\xE7\xE3o.\\n\\nAl\xE9m disso, com intelig\xEAncia artificial, economiza at\xE9 90% do tempo perdido em pedidos recebidos pelo WhatsApp, reduz erros com a automatiza\xE7\xE3o, integra-se a outros sistemas e oferece um e-commerce B2B para os clientes comprarem online, 24 horas por dia.\"\n                                    }\n                                },\n                                {\n                                    \"@type\": \"Question\",\n                                    \"name\": \"Como o Mercos integra vendas e produ\xE7\xE3o?\",\n                                    \"acceptedAnswer\": {\n                                        \"@type\": \"Answer\",\n                                        \"text\": \"O Mercos conecta a \xE1rea comercial ao ch\xE3o de f\xE1brica registrando pedidos em tempo real, atualizando automaticamente o estoque e enviando essas informa\xE7\xF5es para o ERP. Assim, a produ\xE7\xE3o consegue se planejar conforme a demanda real, evitando atrasos, gargalos e rupturas de materiais.\\n\\nEssa integra\xE7\xE3o faz com que o sistema para ind\xFAstria alinhe vendas e produ\xE7\xE3o, aumentando a efici\xEAncia da opera\xE7\xE3o.\"\n                                    }\n                                },\n                                {\n                                    \"@type\": \"Question\",\n                                    \"name\": \"Qual a diferen\xE7a entre o sistema para ind\xFAstria Mercos e um sistema ERP?\",\n                                    \"acceptedAnswer\": {\n                                        \"@type\": \"Answer\",\n                                        \"text\": \"Um ERP \xE9 voltado para a gest\xE3o administrativa, cont\xE1bil e produtiva da empresa, enquanto o Mercos \xE9 um sistema para ind\xFAstria especializado em vendas. Ele atua como uma extens\xE3o comercial do ERP: organiza pedidos, facilita o relacionamento com clientes, d\xE1 mobilidade aos representantes e permite a venda online via e-commerce B2B.\\n\\nEm resumo, o ERP cuida da retaguarda e o Mercos garante que as vendas da ind\xFAstria fluam com agilidade e precis\xE3o. O Mercos se integra a qualquer ERP do mercado.\"\n                                    }\n                                },\n                                {\n                                    \"@type\": \"Question\",\n                                    \"name\": \"Qual a diferen\xE7a entre o Mercos e um CRM?\",\n                                    \"acceptedAnswer\": {\n                                        \"@type\": \"Answer\",\n                                        \"text\": \"O Mercos tamb\xE9m \xE9 um CRM, mas vai al\xE9m do tradicional. Enquanto o CRM tradicional se concentra somente no relacionamento com o cliente, o Mercos combina essa gest\xE3o com recursos de sistema para ind\xFAstria com foco em vendas, como automa\xE7\xE3o de pedidos, controle de estoque, relat\xF3rios estrat\xE9gicos e integra\xE7\xE3o com ERPs e BIs.\\n\\nAssim, ele une a vis\xE3o estrat\xE9gica de um CRM \xE0 efici\xEAncia operacional que a ind\xFAstria precisa para vender com controle e organiza\xE7\xE3o. Por\xE9m, caso a ind\xFAstria j\xE1 conte com um CRM na opera\xE7\xE3o, o Mercos pode ser integrado a ele ou a qualquer CRM do mercado.\"\n                                    }\n                                }\n                            ]\n                        }"
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "new-industry-system-v2" },
          _react2.default.createElement(_NewMenu2.default, { transparentOnTop: true, pixelsToShowMenuWhite: 50, mutableMenu: true, hideOnScroll: true }),
          _react2.default.createElement(
            "section",
            { className: "new-industry-hero hero" },
            _react2.default.createElement(
              "div",
              { className: "container" },
              _react2.default.createElement(
                "div",
                { className: "column" },
                _react2.default.createElement(
                  "h1",
                  null,
                  _react2.default.createElement(
                    "span",
                    { className: "overtitle" },
                    "Sistema para ind\xFAstria n\xB01 do mercado"
                  ),
                  _react2.default.createElement("br", null),
                  _react2.default.createElement(
                    "span",
                    { className: "title" },
                    "Emiss\xE3o de pedidos com IA, automa\xE7\xE3o da for\xE7a de vendas e controle operacional"
                  )
                ),
                _react2.default.createElement(
                  "h2",
                  { className: "description" },
                  "O Mercos \xE9 o software para ind\xFAstria mais pr\xE1tico e completo do mercado, entregando ",
                  _react2.default.createElement(
                    "b",
                    null,
                    "gest\xE3o e controle total de vendas, estoque e equipe, CRM e integra\xE7\xE3o com qualquer ERP"
                  ),
                  " em um s\xF3 lugar"
                ),
                _react2.default.createElement(_DemoForm2.default, { textAlign: "left", buttonVariant: "inverted" })
              ),
              _react2.default.createElement(
                "div",
                { className: "column form-col" },
                _react2.default.createElement(_Picture2.default, { src: "/images/site/landing-pages/industrias/hero-img.png", alt: "Imagem de um homem sorridente com seu celular na m\xE3o, usando o Mercos, o sistema para ind\xFAstria que \xE9 l\xEDder de mercado. \xC9 poss\xEDvel ver gr\xE1ficos, como Curva ABC de Clientes, An\xE1lise de Clientes por regi\xE3o do Brasil. H\xE1 tamb\xE9m lembretes da op\xE7\xE3o de criar pedidos com IA e de acompanhar um vendedor em uma visita que ele far\xE1 a um atacad\xE3o, demonstrando que o Mercos oferece efici\xEAncia e inova\xE7\xE3o industrial" })
              )
            )
          ),
          _react2.default.createElement(_TestimonialsVideoCardsV2.default, { industryVersion: true }),
          _react2.default.createElement(
            "section",
            { className: "benefits-accordion-section" },
            _react2.default.createElement(
              "div",
              { className: "container" },
              _react2.default.createElement(
                "div",
                { className: "content-wrapper" },
                _react2.default.createElement(
                  "div",
                  { className: "features-list" },
                  _react2.default.createElement(
                    "div",
                    { className: "section-header" },
                    _react2.default.createElement(
                      "h3",
                      null,
                      _react2.default.createElement(
                        "span",
                        { className: "overtitle" },
                        "Fim dos erros e retrabalhos"
                      ),
                      _react2.default.createElement(
                        "span",
                        { className: "title" },
                        "Vis\xE3o completa",
                        _react2.default.createElement("br", null),
                        " da sua opera\xE7\xE3o"
                      )
                    ),
                    _react2.default.createElement(
                      "p",
                      { className: "description" },
                      "Centralize as informa\xE7\xF5es da sua ind\xFAstria, ganhe tempo para tarefas estrat\xE9gicas e deixe que a tecnologia do Mercos ajude voc\xEA a vender mais"
                    )
                  ),
                  _react2.default.createElement(
                    _SimpleAccordionContainer2.default,
                    { expand: "arrow", collapsable: true },
                    _react2.default.createElement(
                      _SimpleAccordionItem2.default,
                      { title: "M\xFAltiplas integra\xE7\xF5es", headerTag: "h4", onClick: function onClick() {
                          return _this2.handleAccordionClick(0);
                        } },
                      _react2.default.createElement(
                        "p",
                        null,
                        "Integre o sistema para ind\xFAstria Mercos com ERPs, BIs, CRMs ou os softwares que desejar, de forma simples e segura"
                      ),
                      _react2.default.createElement(_Picture2.default, { className: "mobile-only", src: "/images/site/landing-pages/forca-vendas/conectado.png", alt: "Imagem trazendo logos de empresas as quais o sistema para ind\xFAstria Mercos se integra" })
                    ),
                    _react2.default.createElement(
                      _SimpleAccordionItem2.default,
                      { title: "Solu\xE7\xF5es com Intelig\xEAncia Artificial", headerTag: "h4", onClick: function onClick() {
                          return _this2.handleAccordionClick(1);
                        } },
                      _react2.default.createElement(
                        "p",
                        null,
                        "Nossa IA transforma mensagens de WhatsApp em pedidos em segundos e sugere produtos com base no hist\xF3rico do cliente"
                      ),
                      _react2.default.createElement(_Picture2.default, { className: "mobile-only", src: "/images/site/landing-pages/industrias/solucoes.png", alt: "Interface de pedidos com intelig\xEAncia artificial do Mercos para automatizar vendas" })
                    ),
                    _react2.default.createElement(
                      _SimpleAccordionItem2.default,
                      { title: "Capta\xE7\xE3o e processamento \xE1gil de pedidos", headerTag: "h4", onClick: function onClick() {
                          return _this2.handleAccordionClick(2);
                        } },
                      _react2.default.createElement(
                        "p",
                        null,
                        "Acompanhe os passos das equipes externas e internas enquanto eles tiram pedidos com agilidade e focam em atender com excel\xEAncia"
                      ),
                      _react2.default.createElement(_Picture2.default, { className: "mobile-only", src: "/images/site/landing-pages/industrias/captacao.png", alt: "Dashboard com relat\xF3rios de vendas detalhados no sistema Mercos" })
                    )
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: "main-image desktop-only" },
                  _react2.default.createElement(_Picture2.default, { src: this.accordionImages[this.state.activeAccordion].src, alt: this.accordionImages[this.state.activeAccordion].alt })
                )
              )
            )
          ),
          _react2.default.createElement(
            "section",
            { className: "icon-features-section" },
            _react2.default.createElement(
              "div",
              { className: "container" },
              _react2.default.createElement(
                "div",
                { className: "icon-features" },
                _react2.default.createElement(
                  "div",
                  { className: "icon-feature-item" },
                  _react2.default.createElement(
                    "div",
                    { className: "icon-wrapper" },
                    _react2.default.createElement(_Picture2.default, { src: "/images/site/icons/dolar.svg", alt: "Previsibilidade nas vendas" })
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: "icon-feature-content" },
                    _react2.default.createElement(
                      "p",
                      { className: "icon-feature-title" },
                      "Venda de qualquer lugar, at\xE9 sem internet"
                    ),
                    _react2.default.createElement(
                      "p",
                      { className: "icon-feature-description" },
                      "Sua equipe vende presencialmente, com um aplicativo mobile que funciona mesmo offline, ou vende online com o e-commerce B2B"
                    )
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: "icon-feature-item" },
                  _react2.default.createElement(
                    "div",
                    { className: "icon-wrapper" },
                    _react2.default.createElement(_Picture2.default, { src: "/images/site/icons/graph-arrow-up.png", alt: "Venda de qualquer lugar" })
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: "icon-feature-content" },
                    _react2.default.createElement(
                      "p",
                      { className: "icon-feature-title" },
                      "Tenha previsibilidade na rotina de vendas"
                    ),
                    _react2.default.createElement(
                      "p",
                      { className: "icon-feature-description" },
                      "Acesse indicadores e relat\xF3rios que garantem uma opera\xE7\xE3o anal\xEDtica, eficiente, preditiva e pautada em dados confi\xE1veis"
                    )
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: "icon-feature-item" },
                  _react2.default.createElement(
                    "div",
                    { className: "icon-wrapper" },
                    _react2.default.createElement(_Picture2.default, { src: "/images/site/icons/flag-white.png", alt: "Pol\xEDticas em tempo real" })
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: "icon-feature-content" },
                    _react2.default.createElement(
                      "p",
                      { className: "icon-feature-title" },
                      "Pol\xEDticas atualizadas em tempo real"
                    ),
                    _react2.default.createElement(
                      "p",
                      { className: "icon-feature-description" },
                      "Compartilhe pol\xEDticas comerciais em tempo real e garanta pre\xE7os, descontos e pagamentos aplicados sem erro"
                    )
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: "icon-feature-item" },
                  _react2.default.createElement(
                    "div",
                    { className: "icon-wrapper" },
                    _react2.default.createElement(_Picture2.default, { src: "/images/site/icons/person-frame.png", alt: "Autonomia para compradores" })
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: "icon-feature-content" },
                    _react2.default.createElement(
                      "p",
                      { className: "icon-feature-title" },
                      "D\xEA autonomia para seus compradores"
                    ),
                    _react2.default.createElement(
                      "p",
                      { className: "icon-feature-description" },
                      "Com o Portal do Cliente, um canal digital gratuito e integrado ao Mercos, os compradores acessam hist\xF3ricos e NFs com autonomia"
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(_TwoColsV2.default, {
            overTitle: "Venda online descomplicada",
            title: "E-commerce B2B para vender a qualquer hora",
            description: _react2.default.createElement(
              "h4",
              null,
              "Venda por uma ",
              _react2.default.createElement(
                "b",
                null,
                "loja online personalizada para sua ind\xFAstria"
              ),
              ", permitindo que seu vendedor finalize o pedido ou que seu cliente pague por cart\xE3o, boleto ou pix, usando o Mercos Pay"
            ),
            imageSrc: "/images/site/landing-pages/industrias/e-commerce-b2b.png",
            imageAlt: "Tela do e-commerce B2B para ind\xFAstria Mercos, exibindo produtos como caneca de caf\xE9 e cesta graffiti, com a loja virtual podendo ser personalizada conforme o segmento e setor da ind\xFAstria",
            isReverse: true,
            testimonial: {
              text: "Além de vender online com o e-commerce B2B da Mercos, passamos a transacionar 95% do faturamento diretamente pelo sistema com o Mercos Pay, economizando 2 dias de trabalho por mês. Também reduzimos em 10x o tempo de emissão de notas e cobranças com a integração com nosso ERP.",
              personName: "Allan Gomes",
              companyName: "La Ganexa",
              personImage: "/images/site/depoimentos/allan-gomes.png"
            },
            radialBg: "purple",
            testimonialElementType: "p"
          }),
          _react2.default.createElement(
            "section",
            { className: "resources-section" },
            _react2.default.createElement(
              "div",
              { className: "container" },
              _react2.default.createElement(
                "div",
                { className: "resources-header" },
                _react2.default.createElement(
                  "h3",
                  null,
                  _react2.default.createElement(
                    "span",
                    { className: "overtitle" },
                    "Recursos para a gest\xE3o e suas equipes"
                  ),
                  _react2.default.createElement(
                    "span",
                    { className: "title" },
                    "Confira os diferenciais do Mercos"
                  )
                ),
                _react2.default.createElement(
                  "p",
                  null,
                  "Confira como o sistema para ind\xFAstria Mercos otimiza",
                  _react2.default.createElement("br", null),
                  " sua opera\xE7\xE3o comercial de ponta a ponta, na pr\xE1tica"
                ),
                _react2.default.createElement(
                  "div",
                  { className: "mobile-scroll-indicators" },
                  _react2.default.createElement(
                    "div",
                    { className: "scroll-arrow left " + (this.state.canScrollLeft ? 'active' : ''), onClick: function onClick() {
                        return _this2.handleResourcesScroll('left');
                      } },
                    _react2.default.createElement(_Picture2.default, { src: "/images/site/arrow.svg", alt: "Scroll left" })
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: "scroll-arrow right " + (this.state.canScrollRight ? 'active' : ''), onClick: function onClick() {
                        return _this2.handleResourcesScroll('right');
                      } },
                    _react2.default.createElement(_Picture2.default, { src: "/images/site/arrow.svg", alt: "Scroll right" })
                  )
                )
              )
            ),
            _react2.default.createElement(
              "div",
              { className: "resources-cards-wrapper" },
              _react2.default.createElement(
                _SmoothDragScroll2.default,
                { ref: this.resourcesSliderRef, className: "resources-cards" },
                _react2.default.createElement("div", { className: "card-spacer" }),
                _react2.default.createElement(
                  "div",
                  { className: "resource-card", title: "Acompanhe quanto j\xE1 foi vendido e veja a proje\xE7\xE3o do resultado ao final do m\xEAs, ajustando sua estrat\xE9gia para sempre bater as metas" },
                  _react2.default.createElement(_Picture2.default, { src: "/images/site/landing-pages/industrias/1-evolucao-vendas.png", alt: "Imagem do indicador Evolu\xE7\xE3o de Venda do Mercos, que mostra quanto a ind\xFAstria faturou no m\xEAs e qual seu objetivo por meio de um gr\xE1fico" }),
                  _react2.default.createElement(_Picture2.default, { src: "/images/site/icons/tooltip.svg", alt: "Info", className: "tooltip-icon" })
                ),
                _react2.default.createElement(
                  "div",
                  { className: "resource-card", title: "Centralize todos os pedidos conclu\xEDdos, or\xE7amentos e cancelamentos em um s\xF3 lugar, com filtros para acompanhar as vendas da ind\xFAstria em detalhes" },
                  _react2.default.createElement(_Picture2.default, { src: "/images/site/landing-pages/industrias/2-relatorio-vendas.png", alt: "Imagem do relat\xF3rio de vendas do Mercos, mostrando um gr\xE1fico de pizza que traz as vendas e or\xE7amentos conclu\xEDdos no per\xEDodo definido pela ind\xFAstria" }),
                  _react2.default.createElement(_Picture2.default, { src: "/images/site/icons/tooltip.svg", alt: "Info", className: "tooltip-icon" })
                ),
                _react2.default.createElement(
                  "div",
                  { className: "resource-card", title: "Respondemos a toda sua equipe em at\xE9 20 segundos no chat ou WhatsApp em hor\xE1rio comercial" },
                  _react2.default.createElement(_Picture2.default, { src: "/images/site/landing-pages/industrias/3-suporte-tempo-real.png", alt: "Homem sorridente usando o celular para acionar o chat em tempo real da Mercos. Na conversa \xE9 poss\xEDvel conferir a seguinte troca de mensagem: 'Ol\xE1, estou com uma d\xFAvida, pode me ajudar?', 'Claro, como posso lhe ajudar'?" }),
                  _react2.default.createElement(_Picture2.default, { src: "/images/site/icons/tooltip.svg", alt: "Info", className: "tooltip-icon" })
                ),
                _react2.default.createElement(
                  "div",
                  { className: "resource-card", title: "Analise sua carteira por regi\xE3o, classificando clientes entre prospects, ativos e inativos, priorize atendimentos, evite inativa\xE7\xF5es e gere mais vendas" },
                  _react2.default.createElement(_Picture2.default, { src: "/images/site/landing-pages/industrias/4-acompanhamento-ativo.png", alt: "Imagem mostrando o indicador 'Situa\xE7\xE3o de Carteira de Cliente' do Mercos. \xC9 poss\xEDvel ver o mapa do Brasil divido em cores para o gestor de ind\xFAstria analisar clientes ativos e inativos e formular estrat\xE9gias a partir disso. Verde escuro e claro mostram quais estados a ind\xFAstria tem clientes ativos, amarelo mostra locais com inativos recentes e vermelho mostra locais com inativos antigos" }),
                  _react2.default.createElement(_Picture2.default, { src: "/images/site/icons/tooltip.svg", alt: "Info", className: "tooltip-icon" })
                ),
                _react2.default.createElement(
                  "div",
                  { className: "resource-card", title: "Compare, por vendedor, o n\xFAmero de clientes ativos que fizeram pedidos no m\xEAs, identificando quem movimenta mais as carteiras" },
                  _react2.default.createElement(_Picture2.default, { src: "/images/site/landing-pages/industrias/5-ranking-metas.png", alt: "Imagem mostrando o relat\xF3rio 'Positiva\xE7\xE3o por vendedor' do Mercos, permitindo que a gest\xE3o da ind\xFAstria acompanhe quanto cada vendedor positivou em um per\xEDodo, bem como quantos porcento da meta ele atingiu e sua posi\xE7\xE3o no ranking da equipe" }),
                  _react2.default.createElement(_Picture2.default, { src: "/images/site/icons/tooltip.svg", alt: "Info", className: "tooltip-icon" })
                ),
                _react2.default.createElement(
                  "div",
                  { className: "resource-card", title: "Planeje visitas e organize o tempo de trabalho, otimizando deslocamento e produtividade" },
                  _react2.default.createElement(_Picture2.default, { src: "/images/site/landing-pages/industrias/6-agenda-roterizacao.png", alt: "Imagem mostrando o relat\xF3rio de Pedidos e atendimentos do Mercos, trazendo o 'Or\xE7amento #165', com data, hor\xE1rio e nome do vendedor ao qual o or\xE7amento foi solicitado, bem como o nome do cliente, o valor e a condi\xE7\xE3o de pagamento. Tamb\xE9m \xE9 poss\xEDvel acompanhar liga\xE7\xF5es que os vendedores fizeram e demais contatos com clientes" }),
                  _react2.default.createElement(_Picture2.default, { src: "/images/site/icons/tooltip.svg", alt: "Info", className: "tooltip-icon" })
                ),
                _react2.default.createElement(
                  "div",
                  { className: "resource-card", title: "A Intelig\xEAncia Artificial entende os pedidos que voc\xEA recebe por mensagem, gera uma lista de produtos e lan\xE7a no sistema em segundos" },
                  _react2.default.createElement(_Picture2.default, { src: "/images/site/landing-pages/industrias/7-pedidos-ia.png", alt: "Imagem mostrando o recurso Pedidos com IA do sistema para ind\xFAstria Mercos. \xC9 poss\xEDvel ler uma troca de conversa pelo WhatsApp entre vendedor e cliente, com o vendedor podendo pegar o print da conversa, por exemplo, e lan\xE7ar no Pedidos com IA Mercos, que criar\xE1 o pedido diretamente dentro do sistema usando intelig\xEAncia artificial e ajudando-o a economizar at\xE9 90% do tempo gasto em pedidos e or\xE7amentos" }),
                  _react2.default.createElement(_Picture2.default, { src: "/images/site/icons/tooltip.svg", alt: "Info", className: "tooltip-icon" })
                ),
                _react2.default.createElement(
                  "div",
                  { className: "resource-card", title: "A solu\xE7\xE3o de pagamentos da Mercos permite recebimentos por cart\xE3o, boleto, link de pagamento ou Pix, direto do sistema" },
                  _react2.default.createElement(_Picture2.default, { src: "/images/site/landing-pages/industrias/8-mercos-pay.png", alt: "Tela do Mercos Pay mostrando op\xE7\xF5es de pagamento integradas ao sistema" }),
                  _react2.default.createElement(_Picture2.default, { src: "/images/site/icons/tooltip.svg", alt: "Info", className: "tooltip-icon" })
                ),
                _react2.default.createElement(
                  "div",
                  { className: "resource-card", title: "Analise o relat\xF3rio de comiss\xF5es por vendedor e por per\xEDodo, identifique oportunidades de incentivo e ajuste estrat\xE9gias para aumentar os resultados" },
                  _react2.default.createElement(_Picture2.default, { src: "/images/site/landing-pages/industrias/9-comissionamento.png", alt: "Imagem mostrando o relat\xF3rio de 'Comiss\xE3o por Vendedor' do Mercos, que permite que a gest\xE3o da ind\xFAstria acompanhe de perto o comissionamento da equipe" }),
                  _react2.default.createElement(_Picture2.default, { src: "/images/site/icons/tooltip.svg", alt: "Info", className: "tooltip-icon" })
                )
              )
            )
          ),
          _react2.default.createElement(_UnifiedFAQ2.default, {
            subtitle: _react2.default.createElement(
              "p",
              null,
              "N\xE3o conhece o sistema para ind\xFAstria da Mercos?",
              _react2.default.createElement("br", null),
              " Confira as principais d\xFAvidas que podem surgir."
            ),
            titleId: "industry-system-faq-title",
            faqItems: [{
              question: 'O que é o sistema para indústria Mercos?',
              answer: _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                  "p",
                  null,
                  "O Mercos \xE9 um sistema para ind\xFAstria que elimina retrabalhos e erros na gest\xE3o de pedidos, automatizando o processo comercial, integrando-se a ERPs e a outros sistemas das ind\xFAstrias."
                ),
                _react2.default.createElement(
                  "p",
                  null,
                  "Com e-commerce B2B, intelig\xEAncia artificial e aplicativo mobile (que funciona inclusive offline), permite que representantes e equipes internas emitam pedidos de qualquer lugar, garantindo mais controle, visibilidade e dados confi\xE1veis para decis\xF5es estrat\xE9gicas."
                )
              )
            }, {
              question: 'Quais setores podem usar um sistema para indústria como o Mercos?',
              answer: _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                  "p",
                  null,
                  "O Mercos atende diferentes setores que trabalham no modelo B2B no segmento de bens de consumo, como ind\xFAstrias de alimentos e bebidas, higiene e limpeza, cosm\xE9ticos, materiais de constru\xE7\xE3o, moda e confec\xE7\xE3o, autope\xE7as e muitas outras."
                ),
                _react2.default.createElement(
                  "p",
                  null,
                  "Qualquer empresa industrial que venda para outras empresas e tenha equipes de vendas pode se beneficiar de um sistema para ind\xFAstria como o Mercos, ganhando agilidade nos pedidos e integra\xE7\xE3o total com o restante da opera\xE7\xE3o."
                )
              )
            }, {
              question: 'O Mercos é indicado para minha indústria?',
              answer: _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                  "p",
                  null,
                  "Sim, o Mercos \xE9 um sistema para ind\xFAstria indicado para gestores que desejam otimizar a gest\xE3o comercial e o processo de pedidos B2B. Ele potencializa as vendas ao disponibilizar uma ferramenta pr\xE1tica para representantes e vendedores internos, facilita o acompanhamento de resultados e garante uma vis\xE3o completa da opera\xE7\xE3o."
                ),
                _react2.default.createElement(
                  "p",
                  null,
                  "Al\xE9m disso, com intelig\xEAncia artificial, economiza at\xE9 90% do tempo perdido em pedidos recebidos pelo WhatsApp, reduz erros com a automatiza\xE7\xE3o, integra-se a outros sistemas e oferece um e-commerce B2B para os clientes comprarem online, 24 horas por dia."
                )
              )
            }, {
              question: 'Como o Mercos integra vendas e produção?',
              answer: _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                  "p",
                  null,
                  "O Mercos conecta a \xE1rea comercial ao ch\xE3o de f\xE1brica registrando pedidos em tempo real, atualizando automaticamente o estoque e enviando essas informa\xE7\xF5es para o ERP. Assim, a produ\xE7\xE3o consegue se planejar conforme a demanda real, evitando atrasos, gargalos e rupturas de materiais."
                ),
                _react2.default.createElement(
                  "p",
                  null,
                  "Essa integra\xE7\xE3o faz com que o sistema para ind\xFAstria alinhe vendas e produ\xE7\xE3o, aumentando a efici\xEAncia da opera\xE7\xE3o."
                )
              )
            }, {
              question: 'Qual a diferença entre o sistema para indústria Mercos e um sistema ERP?',
              answer: _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                  "p",
                  null,
                  "Um ERP \xE9 voltado para a gest\xE3o administrativa, cont\xE1bil e produtiva da empresa, enquanto o Mercos \xE9 um sistema para ind\xFAstria especializado em vendas. Ele atua como uma extens\xE3o comercial do ERP: organiza pedidos, facilita o relacionamento com clientes, d\xE1 mobilidade aos representantes e permite a venda online via e-commerce B2B."
                ),
                _react2.default.createElement(
                  "p",
                  null,
                  "Em resumo, o ERP cuida da retaguarda e o Mercos garante que as vendas da ind\xFAstria fluam com agilidade e precis\xE3o. O Mercos se integra a qualquer ERP do mercado."
                )
              )
            }, {
              question: 'Qual a diferença entre o Mercos e um CRM?',
              answer: _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                  "p",
                  null,
                  "O Mercos tamb\xE9m \xE9 um CRM, mas vai al\xE9m do tradicional. Enquanto o CRM tradicional se concentra somente no relacionamento com o cliente, o Mercos combina essa gest\xE3o com recursos de sistema para ind\xFAstria com foco em vendas, como automa\xE7\xE3o de pedidos, controle de estoque, relat\xF3rios estrat\xE9gicos e integra\xE7\xE3o com ERPs e BIs."
                ),
                _react2.default.createElement(
                  "p",
                  null,
                  "Assim, ele une a vis\xE3o estrat\xE9gica de um CRM \xE0 efici\xEAncia operacional que a ind\xFAstria precisa para vender com controle e organiza\xE7\xE3o. Por\xE9m, caso a ind\xFAstria j\xE1 conte com um CRM na opera\xE7\xE3o, o Mercos pode ser integrado a ele ou a qualquer CRM do mercado."
                )
              )
            }]
          }),
          _react2.default.createElement(
            "section",
            { className: "final-cta-section-v5" },
            _react2.default.createElement(_FinalCTACard2.default, null)
          )
        ),
        _react2.default.createElement(_NewFooterV2.default, null)
      );
    }
  }]);

  return IndustrySystemv2;
}(_react.Component);

exports.default = (0, _reactStatic.withRouteData)(function (props) {
  return _react2.default.createElement(IndustrySystemv2, props);
});

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Picture = function Picture(_ref) {
    var src = _ref.src,
        webpSrc = _ref.webpSrc,
        mobileSrc = _ref.mobileSrc,
        alt = _ref.alt,
        className = _ref.className,
        desktop = _ref.desktop,
        mobile = _ref.mobile,
        noWebp = _ref.noWebp,
        fetchPriority = _ref.fetchPriority,
        width = _ref.width,
        height = _ref.height,
        style = _ref.style,
        loading = _ref.loading,
        onLoad = _ref.onLoad,
        srcSet = _ref.srcSet,
        sizes = _ref.sizes,
        decoding = _ref.decoding,
        imgProps = _objectWithoutProperties(_ref, ['src', 'webpSrc', 'mobileSrc', 'alt', 'className', 'desktop', 'mobile', 'noWebp', 'fetchPriority', 'width', 'height', 'style', 'loading', 'onLoad', 'srcSet', 'sizes', 'decoding']);

    // Detect external URLs - if src starts with http:// or https://, it's external
    var isExternal = src && (src.startsWith('http://') || src.startsWith('https://'));
    // Skip WebP for external URLs or when noWebp prop is explicitly set
    var shouldSkipWebp = noWebp || isExternal;

    var extension = src.split('.').pop();
    var isSvg = extension.toLowerCase() === 'svg';
    var webpSource = webpSrc || src.replace('.' + extension, '.webp');
    var desktopClass = desktop ? 'desktop-only' : '';
    var mobileClass = mobile ? 'mobile-only' : '';
    var loadingValue = loading || (fetchPriority ? "eager" : "lazy");

    // Common img props to pass through
    var commonImgProps = _extends({
        className: className + ' ' + desktopClass + ' ' + mobileClass,
        src: '' + src,
        alt: '' + alt,
        loading: loadingValue,
        width: width,
        height: height,
        style: style,
        onLoad: onLoad,
        srcSet: srcSet,
        sizes: sizes,
        decoding: decoding,
        fetchpriority: fetchPriority }, imgProps);

    // For SVG files, just return a simple img tag without picture/source elements
    if (isSvg) {
        return _react2.default.createElement('img', commonImgProps);
    }

    return _react2.default.createElement(
        'picture',
        null,
        mobileSrc && _react2.default.createElement(
            _react.Fragment,
            null,
            !shouldSkipWebp && _react2.default.createElement('source', {
                srcSet: webpSource + ', ' + mobileSrc.replace('.' + extension, '.webp') + ' 2x',
                media: '(max-width: 990px)',
                type: 'image/webp'
            }),
            _react2.default.createElement('source', {
                srcSet: src + ', ' + mobileSrc + ' 2x',
                media: '(max-width: 990px)',
                type: 'image/' + extension
            })
        ),
        !shouldSkipWebp && _react2.default.createElement('source', { srcSet: '' + webpSource, type: 'image/webp' }),
        _react2.default.createElement('img', commonImgProps)
    );
};

exports.default = Picture;

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.createUrlsParamBasedOnCookies = createUrlsParamBasedOnCookies;
exports.redirectWithCookies = redirectWithCookies;

var _jsCookie = __webpack_require__(174);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createUrlsParamBasedOnCookies() {
	var campain = _jsCookie2.default.get('mutm_campaign');
	var medium = _jsCookie2.default.get('mutm_medium');
	var source = _jsCookie2.default.get('mutm_source');
	var term = _jsCookie2.default.get('mutm_term');
	var content = _jsCookie2.default.get('mutm_content');
	var fbclid = _jsCookie2.default.get('mfbclid');
	var gclid = _jsCookie2.default.get('mgclid');
	var gad_campaignid = _jsCookie2.default.get('madscampaignid');
	if (campain || medium || source) {
		var params = campain ? '&utm_campaign=' + campain : '';
		params += medium ? '&utm_medium=' + medium : '';
		params += source ? '&utm_source=' + source : '';
		params += term ? '&utm_term=' + term : '';
		params += content ? '&utm_content=' + content : '';
		params += fbclid ? '&fbclid=' + fbclid : '';
		params += gclid ? '&gclid=' + gclid : '';
		params += gad_campaignid ? '&gad_campaignid=' + gad_campaignid : '';
		return '?' + params.slice(1);
	}
	return '';
}

function redirectWithCookies(url) {
	var paramsCookie = createUrlsParamBasedOnCookies();
	var currentURL = window.location.href;

	_jsCookie2.default.set('trial_page_ref', currentURL, { domain: '.mercos.com' });
	window.location = '' + url + paramsCookie;
}

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(536);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(_ref) {
    var ariaLabel = _ref.ariaLabel,
        children = _ref.children,
        className = _ref.className,
        disabled = _ref.disabled,
        model = _ref.model,
        onClick = _ref.onClick,
        purple = _ref.purple,
        radius = _ref.radius,
        size = _ref.size,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'button' : _ref$type,
        shake = _ref.shake;
    return _react2.default.createElement(
        'button',
        { className: (0, _classnames2.default)('button', model, size, radius, className, purple && 'purple', shake && 'shake'),
            type: type,
            onClick: onClick,
            'aria-label': ariaLabel,
            disabled: disabled },
        children
    );
};

Button.propTypes = {
    className: _propTypes2.default.string,
    ariaLabel: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    children: _propTypes2.default.any,
    model: _propTypes2.default.oneOf(['alert', 'outline', 'no-borders', 'secondary', 'success', 'warning']),
    size: _propTypes2.default.string,
    type: _propTypes2.default.oneOf(['button', 'submit']),
    radius: _propTypes2.default.oneOf(['right-bottom-only', 'half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded', 'italic'])
};

exports.default = Button;

/***/ }),

/***/ 534:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

var _CloseButton = __webpack_require__(538);

var _CloseButton2 = _interopRequireDefault(_CloseButton);

__webpack_require__(540);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCloseButton = function getCloseButton(callbackCloseModal, hasImage) {
  return _react2.default.createElement(
    'div',
    { className: 'site-close-modal-button' },
    hasImage,
    _react2.default.createElement(_CloseButton2.default, { outlineOnly: !hasImage, onClickButton: callbackCloseModal })
  );
};

var Modal = function Modal(_ref) {
  var className = _ref.className,
      overlayColor = _ref.overlayColor,
      imageURL = _ref.imageURL,
      callbackCloseModal = _ref.callbackCloseModal,
      children = _ref.children,
      video = _ref.video,
      overlayStyles = _ref.overlayStyles,
      hideCloseButton = _ref.hideCloseButton;

  var hasImage = Boolean(imageURL);

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('site-modal-container', className) },
    _react2.default.createElement(
      'div',
      {
        className: (0, _classnames2.default)({ 'site-modal-with-image': hasImage, 'site-simple-modal': !hasImage }, video ? 'video' : '', overlayStyles ? overlayStyles : '')
      },
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('site-modal-content text-left', video ? 'video' : '') },
        children
      ),
      hasImage && _react2.default.createElement('div', {
        className: 'site-modal-image',
        style: { background: 'url(\'' + imageURL + '\') no-repeat center' }
      }),
      !hideCloseButton && getCloseButton(callbackCloseModal, hasImage)
    ),
    _react2.default.createElement('div', {
      className: (0, _classnames2.default)('site-modal-overlay', video ? 'video' : '', overlayColor ? overlayColor : ''),
      onClick: callbackCloseModal
    })
  );
};

exports.default = Modal;

/***/ }),

/***/ 536:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var telephoneMask = exports.telephoneMask = function telephoneMask(value) {
    var cleanTelephone = value ? value.replace(/\D/g, "") : '';
    var numberLength = cleanTelephone.length;

    if (numberLength > 10) {
        cleanTelephone = cleanTelephone.slice(0, 7) + '-' + cleanTelephone.slice(7);
    } else if (numberLength > 6 && numberLength < 11) {
        cleanTelephone = cleanTelephone.slice(0, 6) + '-' + cleanTelephone.slice(6);
    }

    if (numberLength > 2) {
        cleanTelephone = cleanTelephone.slice(0, 2) + ') ' + cleanTelephone.slice(2);
    }

    if (numberLength > 0) {
        cleanTelephone = '(' + cleanTelephone.slice(0);
    }

    return cleanTelephone;
};

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(539);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CloseButton = function CloseButton(_ref) {
    var onClickButton = _ref.onClickButton,
        _ref$outlineOnly = _ref.outlineOnly,
        outlineOnly = _ref$outlineOnly === undefined ? false : _ref$outlineOnly;
    return _react2.default.createElement('button', { className: (0, _classnames2.default)({
            'site-close-button-outline': outlineOnly,
            'site-close-button': !outlineOnly
        }), onClick: onClickButton });
};

exports.default = CloseButton;

/***/ }),

/***/ 539:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 540:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = function Input(_ref) {
    var placeholder = _ref.placeholder,
        inputPlaceholder = _ref.inputPlaceholder,
        onChange = _ref.onChange,
        id = _ref.id,
        error = _ref.error,
        value = _ref.value,
        ariaLabel = _ref.ariaLabel,
        _ref$maxLength = _ref.maxLength,
        maxLength = _ref$maxLength === undefined ? '' : _ref$maxLength,
        model = _ref.model,
        autoFocus = _ref.autoFocus,
        size = _ref.size,
        _ref$radius = _ref.radius,
        radius = _ref$radius === undefined ? 'all-rounded' : _ref$radius,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'text' : _ref$type,
        name = _ref.name;
    return _react2.default.createElement(
        'div',
        { className: 'floating-label-wrapper' },
        _react2.default.createElement('input', { className: (0, _classnames2.default)('input', error && 'error', model, size, radius),
            'aria-label': ariaLabel,
            autoFocus: autoFocus,
            id: id,
            maxLength: maxLength,
            onChange: onChange,
            placeholder: inputPlaceholder,
            type: type,
            value: value,
            name: name || id,
            required: true
        }),
        _react2.default.createElement(
            'span',
            { className: 'floating-label' },
            placeholder
        )
    );
};

Input.propTypes = {
    id: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    inputPlaceholder: _propTypes2.default.string,
    error: _propTypes2.default.bool,
    value: _propTypes2.default.string,
    ariaLabel: _propTypes2.default.string,
    maxLength: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    autoFocus: _propTypes2.default.bool,
    model: _propTypes2.default.oneOf(['outline', 'no-borders', 'secondary', 'success', 'alert', 'warning']),
    size: _propTypes2.default.string,
    radius: _propTypes2.default.oneOf(['half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded'])
};

exports.default = Input;

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _jsCookie = __webpack_require__(174);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _Button = __webpack_require__(533);

var _Button2 = _interopRequireDefault(_Button);

var _Modal = __webpack_require__(535);

var _Modal2 = _interopRequireDefault(_Modal);

var _Input = __webpack_require__(546);

var _Input2 = _interopRequireDefault(_Input);

var _RDGateway = __webpack_require__(175);

var _RDGateway2 = _interopRequireDefault(_RDGateway);

var _masks = __webpack_require__(537);

var _Utm = __webpack_require__(532);

var _ModalTestimonials = __webpack_require__(552);

var _ModalTestimonials2 = _interopRequireDefault(_ModalTestimonials);

var _InputFloatingLabel = __webpack_require__(541);

var _InputFloatingLabel2 = _interopRequireDefault(_InputFloatingLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FIELDS = ['name', 'email', 'telephone', 'activity', 'users'];

var ACTIVITY = {
    industria: 'Indústria',
    distribuicao: 'Distribuição',
    rep: 'Representação Comercial',
    outra: 'Outro'
};

var USERS = {
    um: '1',
    cinco: '2-5',
    vinte: '6-20',
    cinquenta: '21-50',
    cinquentaum: '51 ou mais'
};

var DemoForm = function (_Component) {
    _inherits(DemoForm, _Component);

    function DemoForm(props) {
        _classCallCheck(this, DemoForm);

        var _this = _possibleConstructorReturn(this, (DemoForm.__proto__ || Object.getPrototypeOf(DemoForm)).call(this, props));

        _this.handleActivityDropdownClick = function (e) {
            var dropdown = e.currentTarget.nextElementSibling;
            var button = e.currentTarget;

            dropdown.classList.toggle('show');
            button.classList.toggle('expanded');
        };

        _this.handleUsersDropdownClick = function (e) {
            var dropdown = e.currentTarget.nextElementSibling;
            var button = e.currentTarget;

            dropdown.classList.toggle('show');
            button.classList.toggle('expanded');
        };

        _this.handleActivityOptionClick = function (activity) {
            var button = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown-button');
            var dropdown = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown');

            dropdown.classList.remove('show');
            button.classList.remove('expanded');
            button.classList.add('option-selected');
            button.textContent = activity;

            _this.handlerEnterpriseActivity(activity);
        };

        _this.handleUsersOptionClick = function (users) {
            var wrapper = document.activeElement.closest('.activity-wrapper');
            var button = wrapper.querySelector('.activity-dropdown-button');
            var dropdown = wrapper.querySelector('.activity-dropdown');

            dropdown.classList.remove('show');
            button.classList.remove('expanded');
            button.classList.add('option-selected');
            button.textContent = users;

            _this.handlerUsers(users);
        };

        _this.rdGateway = new _RDGateway2.default();
        _this.state = _this.getInitialState(props);

        globalThis.optimizeOpenPopup = function () {
            _this.setState({ showDemoModal: true });
        };
        return _this;
    }

    _createClass(DemoForm, [{
        key: 'getInitialState',
        value: function getInitialState(props) {
            var initialObject = {
                showDemoModal: false,
                company: '',
                name: '',
                email: '',
                telephone: '',
                activity: '',
                users: '',
                typingTimeout: 0,
                partnerId: props.partnerId,
                rdWhatsappLauncherReady: false
            };
            FIELDS.forEach(function (campo) {
                initialObject[campo + 'Error'] = false;
                initialObject[campo + 'Typing'] = false;
            });
            return initialObject;
        }
    }, {
        key: 'setDataByCookie',
        value: function setDataByCookie() {
            this.setState({
                partnerId: _jsCookie2.default.get('leaderPartnerId') || this.state.partnerId || ''
            });
        }
    }, {
        key: 'openDemoModal',
        value: function openDemoModal(e) {
            e.preventDefault();

            this.setState({
                showDemoModal: true
            });
        }
    }, {
        key: 'closeDemoModal',
        value: function closeDemoModal() {
            this.setState({
                showDemoModal: false
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var _this2 = this,
                _setState;

            var name = e.target.id;
            var value = e.target.value;
            var company = this.state.name + ' - ' + this.state.email;

            if (name === 'telephone') {
                value = this.telephoneMask(value);
            } else if (name === 'name') {
                company = value + ' - ' + this.state.email;
            } else if (name === 'email') {
                value = value.trim();
                company = this.state.name + ' - ' + value;
            }

            if (this.state.typingTimeout) {
                clearTimeout(this.state.typingTimeout);
            }

            this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, 'company', company), _defineProperty(_setState, name + 'Error', false), _defineProperty(_setState, name + 'Typing', true), _defineProperty(_setState, 'typingTimeout', setTimeout(function () {
                if (name === 'email' && _this2.validateEmail(_this2.state.email)) {}
            }, 3000)), _setState));
        }
    }, {
        key: 'handlerEnterpriseActivity',
        value: function handlerEnterpriseActivity(tipo) {
            this.setState({ 'activity': tipo });
        }
    }, {
        key: 'getSelectedActivity',
        value: function getSelectedActivity(selected) {
            return this.state.activity === selected ? 'active' : '';
        }
    }, {
        key: 'handlerUsers',
        value: function handlerUsers(tipo) {
            this.setState({ 'users': tipo });
        }
    }, {
        key: 'getSelectedUsers',
        value: function getSelectedUsers(selected) {
            return this.state.users === selected ? 'active' : '';
        }
    }, {
        key: 'validation',
        value: function validation() {
            var _this3 = this;

            var newState = {};
            var fieldsToValidate = FIELDS;

            var regexTelephone = /^\([1-9]{2}\) [2-9][0-9]{3,4}\-[0-9]{4}$/;
            fieldsToValidate.forEach(function (campo) {
                newState[campo + 'Error'] = !_this3.state[campo];
                switch (campo) {
                    case 'email':
                        {
                            newState[campo + 'Error'] = !_this3.validateEmail(_this3.state[campo]);
                            break;
                        }
                    case 'telephone':
                        {
                            newState[campo + 'Error'] = !regexTelephone.test(_this3.state[campo]);
                            break;
                        }
                }
            });
            this.setState(newState);
            var lista = Object.values(newState);
            return lista.every(function (value) {
                return !value;
            });
        }
    }, {
        key: 'validateEmail',
        value: function validateEmail(email) {
            if (!email) return false;
            var trimmedEmail = email.trim();
            var regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return regexEmail.test(trimmedEmail.toLowerCase());
        }
    }, {
        key: 'submitForm',
        value: function submitForm(e) {
            e.preventDefault();
            if (this.validation()) {
                var data = {
                    conversion_identifier: 'solicite-uma-demonstracao-do-meus-pedidos',
                    'cf_tipo_de_conversao': 'Solicitou demonstração',
                    company_name: this.state.company,
                    name: this.state.name,
                    email: this.state.email,
                    personal_phone: this.state.telephone,
                    'cf_atividade_da_empresa': this.state.activity,
                    event_action: 'solicitou_demo',
                    event_label: 'forca_de_vendas'
                };

                data['cf_numero_de_vendedores'] = this.state.users;

                if (this.state.partnerId) {
                    data.conversion_identifier = 'canais-lp';
                    data['cf_codigo_do_parceiro_meus_pedidos'] = this.state.partnerId;
                }

                var redirectLink = 'https://mercos.com/tp/solicitou-demo-fv/';
                if (this.state.activity === ACTIVITY.outra) redirectLink = 'https://materiais.mercos.com/tp-smb-solicitou-demo';else if (this.state.activity === ACTIVITY.rep) redirectLink = 'https://materiais.mercos.com/tp-reps-solicitou-demo';

                this.rdGateway.sendToRDStation(data, redirectLink);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setDataByCookie();
            if (this.props.replaceTrialWithWhatsapp) {
                this.watchRDWhatsappLauncher();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.stopRDWhatsappPoll();
            if (this.rdWhatsappFallbackTimer) {
                clearTimeout(this.rdWhatsappFallbackTimer);
            }
        }
    }, {
        key: 'isRDWhatsappLauncherReady',
        value: function isRDWhatsappLauncherReady() {
            if (typeof document === 'undefined') return false;
            return Boolean(document.querySelector('.bricks--floating--button.rdstation-popup-js-floating-button'));
        }
    }, {
        key: 'stopRDWhatsappPoll',
        value: function stopRDWhatsappPoll() {
            if (this.rdWhatsappPollTimer) {
                clearInterval(this.rdWhatsappPollTimer);
                this.rdWhatsappPollTimer = null;
            }
        }
    }, {
        key: 'watchRDWhatsappLauncher',
        value: function watchRDWhatsappLauncher() {
            var _this4 = this;

            if (this.isRDWhatsappLauncherReady()) {
                this.setState({ rdWhatsappLauncherReady: true });
                return;
            }

            if (typeof document === 'undefined') return;

            this.rdWhatsappPollTimer = setInterval(function () {
                if (!_this4.isRDWhatsappLauncherReady()) return;
                _this4.setState({ rdWhatsappLauncherReady: true });
                _this4.stopRDWhatsappPoll();
            }, 300);

            this.rdWhatsappFallbackTimer = setTimeout(function () {
                _this4.stopRDWhatsappPoll();
            }, 7000);
        }
    }, {
        key: 'openRDWhatsappLauncher',
        value: function openRDWhatsappLauncher(e) {
            e.preventDefault();

            if (typeof window !== 'undefined' && typeof window.__mercosOpenRDWhatsappLauncher === 'function') {
                if (window.__mercosOpenRDWhatsappLauncher()) return;
            }

            var launcher = typeof document !== 'undefined' ? document.querySelector('.bricks--floating--button.rdstation-popup-js-floating-button') : null;

            if (launcher) {
                launcher.click();
                return;
            }

            (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
        }
    }, {
        key: 'getDemoModal',
        value: function getDemoModal() {
            var _this5 = this;

            if (this.props.minimalStyle) {
                return _react2.default.createElement(
                    _Modal2.default,
                    { callbackCloseModal: function callbackCloseModal() {
                            return _this5.closeDemoModal();
                        }, className: this.props.formHeroStyle ? 'form-hero-demo-modal' : undefined },
                    _react2.default.createElement(
                        'div',
                        { className: 'container-form-modal modal-context' },
                        this.getInlineForm()
                    )
                );
            } else if (this.props.modalSmall) {
                return this.getDemoModalSmall();
            } else {
                return _react2.default.createElement(
                    _Modal2.default,
                    { callbackCloseModal: function callbackCloseModal() {
                            return _this5.closeDemoModal();
                        }, className: 'site-simple-modal-testimonials' },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header-logo' },
                        _react2.default.createElement('div', { className: 'logo-mercos-new-home' })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'container-form-modal' },
                        _react2.default.createElement(
                            'h4',
                            null,
                            'Solicite uma demonstra\xE7\xE3o'
                        ),
                        this.getForm()
                    ),
                    _react2.default.createElement(_ModalTestimonials2.default, null)
                );
            }
        }
    }, {
        key: 'getDemoModalSmall',
        value: function getDemoModalSmall() {
            var _this6 = this;

            return _react2.default.createElement(
                _Modal2.default,
                { callbackCloseModal: function callbackCloseModal() {
                        return _this6.closeDemoModal();
                    } },
                _react2.default.createElement(
                    'div',
                    { className: 'new-form-wrapper' },
                    _react2.default.createElement(
                        'div',
                        { className: 'container-form-modal' },
                        this.getFormFloatingLabel()
                    )
                )
            );
        }
    }, {
        key: 'telephoneMask',
        value: function telephoneMask(value) {
            var cleanTelephone = value ? value.replace(/\D/g, '') : '';
            var numberLength = cleanTelephone.length;

            if (numberLength > 10) {
                cleanTelephone = cleanTelephone.slice(0, 7) + '-' + cleanTelephone.slice(7);
            } else if (numberLength > 6 && numberLength < 11) {
                cleanTelephone = cleanTelephone.slice(0, 6) + '-' + cleanTelephone.slice(6);
            }

            if (numberLength > 2) {
                cleanTelephone = cleanTelephone.slice(0, 2) + ') ' + cleanTelephone.slice(2);
            }

            if (numberLength > 0) {
                cleanTelephone = '(' + cleanTelephone.slice(0);
            }

            return cleanTelephone;
        }
    }, {
        key: 'getForm',
        value: function getForm() {
            var _this7 = this;

            return _react2.default.createElement(
                'form',
                { action: '.', method: 'POST', className: 'form-rounded-inputs', onSubmit: function onSubmit(e) {
                        return _this7.submitForm(e);
                    } },
                _react2.default.createElement('input', { type: 'hidden', name: 'company', value: this.state.company }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: 'name' },
                    'Nome'
                ),
                _react2.default.createElement(_Input2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                        return _this7.handleChange(e);
                    }, error: this.state.nameError, autoFocus: true }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: 'email' },
                    'E-mail'
                ),
                _react2.default.createElement(_Input2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                        return _this7.handleChange(e);
                    }, error: this.state.emailError }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: 'telephone' },
                    'Telefone'
                ),
                _react2.default.createElement(_Input2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                        return _this7.handleChange(e);
                    }, error: this.state.telephoneError, maxLength: '15' }),
                _react2.default.createElement(
                    'label',
                    null,
                    'Qual \xE9 a atividade da sua empresa?'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'group-buttons' },
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                return _this7.handlerEnterpriseActivity(ACTIVITY.industria);
                            } },
                        'Ind\xFAstria'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                return _this7.handlerEnterpriseActivity(ACTIVITY.distribuicao);
                            } },
                        'Distribui\xE7\xE3o'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                return _this7.handlerEnterpriseActivity(ACTIVITY.rep);
                            } },
                        'Representante comercial'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                return _this7.handlerEnterpriseActivity(ACTIVITY.outra);
                            } },
                        'Outra'
                    ),
                    this.state.activityError ? _react2.default.createElement(
                        'div',
                        { style: { color: 'red' } },
                        'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                    ) : null
                ),
                _react2.default.createElement(
                    'label',
                    null,
                    'Qual \xE9 o n\xFAmero de vendedores da sua empresa?'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'group-buttons' },
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.um), onClick: function onClick() {
                                return _this7.handlerUsers(USERS.um);
                            } },
                        '1'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.cinco), onClick: function onClick() {
                                return _this7.handlerUsers(USERS.cinco);
                            } },
                        '2-5'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.vinte), onClick: function onClick() {
                                return _this7.handlerUsers(USERS.vinte);
                            } },
                        '6-20'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.cinquenta), onClick: function onClick() {
                                return _this7.handlerUsers(USERS.cinquenta);
                            } },
                        '21-50'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.cinquentaum), onClick: function onClick() {
                                return _this7.handlerUsers(USERS.cinquentaum);
                            } },
                        '51 ou mais'
                    ),
                    this.state.usersError ? _react2.default.createElement(
                        'div',
                        { style: { color: 'red' } },
                        'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                    ) : null
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'submit-demo-modal' },
                    _react2.default.createElement(
                        _Button2.default,
                        { type: 'submit', radius: this.props.contaAzul ? 'all-rounded' : 'half-rounded', className: this.props.contaAzul && 'conta-azul' },
                        this.props.children || 'SOLICITAR'
                    )
                )
            );
        }
    }, {
        key: 'getFormFloatingLabel',
        value: function getFormFloatingLabel() {
            var _this8 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'new-form new-form-floating-inputs' },
                    _react2.default.createElement(
                        'p',
                        { className: 'new-form-title' },
                        'Solicite uma demonstra\xE7\xE3o'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'new-form-subtitle' },
                        'Um de nossos consultores entrar\xE1 em contato.'
                    ),
                    _react2.default.createElement(
                        'form',
                        { action: '.', method: 'POST', className: 'new-form', onSubmit: function onSubmit(e) {
                                return _this8.submitForm(e);
                            } },
                        _react2.default.createElement(_Input2.default, { type: 'hidden', name: 'company', value: this.state.company }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                                return _this8.handleChange(e);
                            }, error: this.state.nameError, placeholder: 'Nome' }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this8.handleChange(e);
                            }, error: this.state.emailError, placeholder: 'E-mail profissional' }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                                return _this8.handleChange(e);
                            }, error: this.state.telephoneError, maxLength: '15', placeholder: 'Telefone' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleActivityDropdownClick },
                                'Selecione uma op\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                            return _this8.handleActivityOptionClick(ACTIVITY.industria);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-industrias.svg' }),
                                    'Ind\xFAstrias'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                            return _this8.handleActivityOptionClick(ACTIVITY.distribuicao);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-distribuidoras.svg' }),
                                    'Distribuidoras'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                            return _this8.handleActivityOptionClick(ACTIVITY.rep);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-representates.svg' }),
                                    'Representantes'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                            return _this8.handleActivityOptionClick(ACTIVITY.outra);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-outros.svg' }),
                                    'Outra'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                'Qual \xE9 a atividade da sua empresa?'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'wrapper-input-vendedores' },
                                _react2.default.createElement(
                                    'p',
                                    { className: 'label' },
                                    'Qual \xE9 o n\xFAmero de vendedores da sua empresa?'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'group-buttons' },
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.um), onClick: function onClick() {
                                                return _this8.handlerUsers(USERS.um);
                                            } },
                                        '1'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.cinco), onClick: function onClick() {
                                                return _this8.handlerUsers(USERS.cinco);
                                            } },
                                        '2-5'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.vinte), onClick: function onClick() {
                                                return _this8.handlerUsers(USERS.vinte);
                                            } },
                                        '6-20'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.cinquenta), onClick: function onClick() {
                                                return _this8.handlerUsers(USERS.cinquenta);
                                            } },
                                        '21-50'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.cinquentaum), onClick: function onClick() {
                                                return _this8.handlerUsers(USERS.cinquentaum);
                                            } },
                                        '51 ou mais'
                                    ),
                                    this.state.usersError ? _react2.default.createElement(
                                        'div',
                                        { style: { color: 'red' } },
                                        'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                                    ) : null
                                )
                            ),
                            this.state.activityError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', className: 'new-submit new-button' },
                                'solicitar demonstra\xE7\xE3o'
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'getNewForm',
        value: function getNewForm() {
            var _this9 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'form-container' },
                    this.props.title === false ? null : _react2.default.createElement(
                        'div',
                        { className: 'form-title' },
                        this.props.title ? this.props.title : 'Preencha o formulário abaixo e solicite uma demonstração'
                    ),
                    _react2.default.createElement(
                        'form',
                        { action: '.', method: 'POST', className: 'new-form', onSubmit: function onSubmit(e) {
                                return _this9.submitForm(e);
                            } },
                        _react2.default.createElement(_Input2.default, { type: 'hidden', name: 'company', value: this.state.company }),
                        _react2.default.createElement(_Input2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                                return _this9.handleChange(e);
                            }, error: this.state.nameError, placeholder: 'Nome' }),
                        _react2.default.createElement(_Input2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this9.handleChange(e);
                            }, error: this.state.emailError, placeholder: 'E-mail profissional' }),
                        _react2.default.createElement(_Input2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                                return _this9.handleChange(e);
                            }, error: this.state.telephoneError, maxLength: '15', placeholder: 'Telefone' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleActivityDropdownClick },
                                'Selecione uma op\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                            return _this9.handleActivityOptionClick(ACTIVITY.industria);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-industrias.svg' }),
                                    'Ind\xFAstrias'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                            return _this9.handleActivityOptionClick(ACTIVITY.distribuicao);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-distribuidoras.svg' }),
                                    'Distribuidoras'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                            return _this9.handleActivityOptionClick(ACTIVITY.rep);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-representates.svg' }),
                                    'Representantes'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                            return _this9.handleActivityOptionClick(ACTIVITY.outra);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-outros.svg' }),
                                    'Outra'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                'Qual \xE9 a atividade da sua empresa?'
                            ),
                            this.state.activityError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', className: 'new-submit new-button' },
                                'solicitar demonstra\xE7\xE3o'
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'getInlineForm',
        value: function getInlineForm() {
            var _this10 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'form-container' },
                    !this.props.hideTitle && this.props.title === false ? null : !this.props.hideTitle ? _react2.default.createElement(
                        'div',
                        { className: 'form-title' },
                        this.props.title ? this.props.title : 'Preencha o formulário abaixo e solicite uma demonstração'
                    ) : null,
                    _react2.default.createElement(
                        'form',
                        { action: '.', method: 'POST', className: 'new-form', onSubmit: function onSubmit(e) {
                                return _this10.submitForm(e);
                            } },
                        _react2.default.createElement(_Input2.default, { type: 'hidden', name: 'company', value: this.state.company }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                                return _this10.handleChange(e);
                            }, error: this.state.nameError, placeholder: this.props.formHeroStyle ? 'Nome completo' : 'Nome', inputPlaceholder: this.props.formHeroStyle ? 'Seu nome completo' : undefined }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this10.handleChange(e);
                            }, error: this.state.emailError, placeholder: this.props.formHeroStyle ? 'E-mail profissional' : 'Seu e-mail', inputPlaceholder: this.props.formHeroStyle ? 'seu@empresa.com.br' : undefined }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                                return _this10.handleChange(e);
                            }, error: this.state.telephoneError, maxLength: '15', placeholder: this.props.formHeroStyle ? 'Telefone / WhatsApp' : 'Telefone', inputPlaceholder: this.props.formHeroStyle ? '(00) 00000-0000' : undefined }),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleActivityDropdownClick },
                                'Selecione uma op\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                            return _this10.handleActivityOptionClick(ACTIVITY.industria);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-industrias.svg' }),
                                    'Ind\xFAstrias'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                            return _this10.handleActivityOptionClick(ACTIVITY.distribuicao);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-distribuidoras.svg' }),
                                    'Distribuidoras'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                            return _this10.handleActivityOptionClick(ACTIVITY.rep);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-representates.svg' }),
                                    'Representantes'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                            return _this10.handleActivityOptionClick(ACTIVITY.outra);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-outros.svg' }),
                                    'Outra'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                this.props.formHeroStyle ? 'Atividade da sua empresa' : 'Qual é a atividade da sua empresa?'
                            ),
                            this.state.activityError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleUsersDropdownClick },
                                'Selecione uma op\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.um), onClick: function onClick() {
                                            return _this10.handleUsersOptionClick(USERS.um);
                                        } },
                                    '1'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.cinco), onClick: function onClick() {
                                            return _this10.handleUsersOptionClick(USERS.cinco);
                                        } },
                                    '2-5'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.vinte), onClick: function onClick() {
                                            return _this10.handleUsersOptionClick(USERS.vinte);
                                        } },
                                    '6-20'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.cinquenta), onClick: function onClick() {
                                            return _this10.handleUsersOptionClick(USERS.cinquenta);
                                        } },
                                    '21-50'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.cinquentaum), onClick: function onClick() {
                                            return _this10.handleUsersOptionClick(USERS.cinquentaum);
                                        } },
                                    '51 ou mais'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                'Quantidade de vendedores da sua empresa'
                            ),
                            this.state.usersError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', className: 'new-submit new-button' },
                                this.props.submitButtonText || 'solicitar demonstração'
                            )
                        ),
                        this.props.formHeroStyle && _react2.default.createElement(
                            'div',
                            { className: 'form-hero-footer' },
                            _react2.default.createElement(
                                'span',
                                null,
                                'Especialista dedicado'
                            ),
                            _react2.default.createElement('span', { className: 'form-hero-footer__dot', 'aria-hidden': 'true' }),
                            _react2.default.createElement(
                                'span',
                                null,
                                'Demonstra\xE7\xE3o personalizada'
                            )
                        ),
                        this.props.showTrialLink && _react2.default.createElement(
                            'div',
                            { className: 'trial-link-wrapper' },
                            _react2.default.createElement(
                                'span',
                                { className: 'trial-link-text' },
                                'ou '
                            ),
                            _react2.default.createElement(
                                'a',
                                {
                                    href: 'https://app.mercos.com/cadastro/',
                                    className: 'trial-link',
                                    onClick: function onClick(e) {
                                        e.preventDefault();
                                        (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                                    }
                                },
                                'Fa\xE7a um teste gr\xE1tis \u203A'
                            )
                        ),
                        !this.props.showTrialLink && _react2.default.createElement(
                            'div',
                            { className: 'inline-trial-link modal-hide' },
                            _react2.default.createElement(
                                'a',
                                {
                                    href: '#',
                                    onClick: function onClick() {
                                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                                    },
                                    title: 'Fa\xE7a um teste gr\xE1tis'
                                },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'ou-text' },
                                    'ou'
                                ),
                                ' fa\xE7a um teste gr\xE1tis \u203A'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'inline-trial-info' },
                                'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a ao terminar o per\xEDodo gr\xE1tis'
                            )
                        ),
                        this.props.showTrialLink && _react2.default.createElement(
                            'p',
                            { className: 'inline-form-trial-info' },
                            'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a autom\xE1tica'
                        )
                    )
                )
            );
        }
    }, {
        key: 'getCTA',
        value: function getCTA() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'cta-text' },
                    _react2.default.createElement(
                        'p',
                        { className: 'font-light font-12' },
                        'explore todos os recursos ',
                        _react2.default.createElement(
                            'span',
                            { className: 'cta-text-separator' },
                            '| '
                        ),
                        'n\xE3o precisa de cart\xE3o de cr\xE9dito ',
                        _react2.default.createElement(
                            'span',
                            { className: 'cta-text-separator' },
                            '| '
                        ),
                        'simples de usar'
                    )
                )
            );
        }
    }, {
        key: 'getModalButton',
        value: function getModalButton() {
            var _this11 = this;

            return _react2.default.createElement(
                'button',
                {
                    href: '.',
                    className: this.props.buttonShadow ? 'btn-white-shadow btn-modal ' : 'new-button button-secondary btn-modal ' + (this.props.darkBg ? 'button-secondary' : 'button-secondary-black') + ' button-cta',
                    onClick: function onClick(e) {
                        return _this11.openDemoModal(e);
                    },
                    title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                },
                this.props.fixedBottomBar ? 'pedir demonstração' : this.props.modalButtonText || 'peça uma demonstração'
            );
        }
    }, {
        key: 'getModalLink',
        value: function getModalLink() {
            var _this12 = this;

            return _react2.default.createElement(
                'div',
                { className: 'or-demo-wrapper' },
                this.props.showOr && _react2.default.createElement(
                    'span',
                    { style: { textDecoration: 'none' } },
                    ' ou '
                ),
                _react2.default.createElement(
                    'a',
                    {
                        href: '.',
                        className: 'button-txt btn-modal ' + (this.props.darkBg ? 'button-txt-white' : ''),
                        onClick: function onClick(e) {
                            return _this12.openDemoModal(e);
                        },
                        title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                    },
                    this.props.modalButtonText || 'peça uma demonstração ›'
                )
            );
        }
    }, {
        key: 'getTrialButton',
        value: function getTrialButton() {
            return _react2.default.createElement(
                'button',
                {
                    className: this.props.buttonShadow ? 'btn-green-shadow btn-trial' : 'new-button button-primary btn-trial button-cta button-trial ' + (this.props.darkBg ? 'dark-bg' : ''),
                    onClick: function onClick() {
                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                    },
                    href: '#',
                    title: 'Cadastre-se no Mercos!'
                },
                this.props.trialAndDemo ? this.props.trialAndDemo : 'teste grátis'
            );
        }
    }, {
        key: 'getTrialAndDemo',
        value: function getTrialAndDemo() {
            var _this13 = this;

            if (this.props.minimalStyle) {
                var demoButtonClass = this.props.invertButtons ? 'button-primary' : 'button-secondary';
                var trialButtonClass = this.props.invertButtons ? 'button-secondary' : 'button-primary';

                return _react2.default.createElement(
                    'div',
                    { className: 'wrapper-trial-and-demo mobile-only' },
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'new-button ' + demoButtonClass + ' ' + (this.props.darkBg ? 'dark-bg' : ''),
                            onClick: function onClick(e) {
                                return _this13.openDemoModal(e);
                            },
                            title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                        },
                        this.props.modalButtonText || 'peça uma demonstração'
                    ),
                    !this.props.hideTrialButton && _react2.default.createElement(
                        'button',
                        {
                            className: 'new-button ' + trialButtonClass + ' ' + (this.props.darkBg ? 'dark-bg' : ''),
                            onClick: function onClick() {
                                return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                            },
                            href: '#',
                            title: 'Cadastre-se no Mercos!'
                        },
                        this.props.trialAndDemo || 'Faça um teste grátis'
                    ),
                    this.props.invertButtons && _react2.default.createElement(
                        'p',
                        { className: 'trial-info-text' },
                        'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a autom\xE1tica'
                    )
                );
            }

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'wrapper-trial-and-demo ' + (this.props.reverseButtons ? 'reverse-buttons' : '') },
                    !this.props.hideTrialButton && this.getTrialButton(),
                    this.props.modalLink ? this.getModalLink() : this.getModalButton()
                ),
                this.props.ctaText ? this.getCTA() : ''
            );
        }
    }, {
        key: 'getNewFormButtons',
        value: function getNewFormButtons() {
            var _this14 = this;

            var _props = this.props,
                buttonVariant = _props.buttonVariant,
                textAlign = _props.textAlign,
                ctaButtonText = _props.ctaButtonText,
                demoButtonText = _props.demoButtonText,
                bottomText = _props.bottomText;


            var isWhiteVariant = buttonVariant === 'white' || buttonVariant === 'inverted-white';
            var isInverted = buttonVariant === 'inverted' || buttonVariant === 'inverted-white';

            // Determine outline color (white or green)
            var outlineClass = isWhiteVariant ? 'new-form-btn-bordered-white' : 'new-form-btn-bordered-green';

            // Default: Faça=solid, Peça=outline
            // Inverted: Peça=solid, Faça=outline
            var trialButtonClass = isInverted ? 'new-form-btn ' + outlineClass : 'new-form-btn new-form-btn-solid-green';
            var demoButtonClass = isInverted ? 'new-form-btn new-form-btn-solid-green' : 'new-form-btn ' + outlineClass;

            var trialButton = _react2.default.createElement(
                'button',
                {
                    className: trialButtonClass,
                    onClick: function onClick() {
                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                    },
                    title: 'Cadastre-se no Mercos!'
                },
                ctaButtonText || 'Faça um teste grátis'
            );

            var whatsappButton = _react2.default.createElement(
                'button',
                {
                    className: trialButtonClass + ' new-form-whatsapp-btn',
                    onClick: function onClick(e) {
                        return _this14.openRDWhatsappLauncher(e);
                    },
                    title: 'Fale conosco no WhatsApp'
                },
                _react2.default.createElement(
                    'span',
                    { className: 'new-form-whatsapp-icon', 'aria-hidden': 'true' },
                    _react2.default.createElement(_Picture2.default, { src: '/images/site/whatsapp.png', alt: '' })
                ),
                this.props.whatsappButtonText || 'Fale conosco no WhatsApp'
            );

            var demoButton = _react2.default.createElement(
                'button',
                {
                    className: demoButtonClass,
                    onClick: function onClick(e) {
                        return _this14.openDemoModal(e);
                    },
                    title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                },
                demoButtonText || 'Peça uma demonstração'
            );

            var primaryButton = this.props.replaceTrialWithWhatsapp && this.state.rdWhatsappLauncherReady ? whatsappButton : trialButton;
            var currentBottomText = this.props.replaceTrialWithWhatsapp && this.state.rdWhatsappLauncherReady ? this.props.whatsappBottomText : bottomText;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'new-form-buttons-wrapper text-align-' + textAlign },
                    _react2.default.createElement(
                        'div',
                        { className: 'new-form-buttons-container' },
                        isInverted ? _react2.default.createElement(
                            _react.Fragment,
                            null,
                            demoButton,
                            primaryButton
                        ) : _react2.default.createElement(
                            _react.Fragment,
                            null,
                            primaryButton,
                            demoButton
                        )
                    ),
                    currentBottomText && _react2.default.createElement(
                        'p',
                        { className: 'new-form-bottom-text' },
                        currentBottomText.includes('|') ? _react2.default.createElement(
                            _react.Fragment,
                            null,
                            _react2.default.createElement(
                                'span',
                                { className: 'desktop-text' },
                                currentBottomText
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'mobile-text' },
                                currentBottomText.split('|').map(function (part, index) {
                                    return _react2.default.createElement(
                                        _react.Fragment,
                                        { key: index },
                                        part.trim(),
                                        index < currentBottomText.split('|').length - 1 && _react2.default.createElement('br', null)
                                    );
                                })
                            )
                        ) : currentBottomText
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this15 = this;

            // Only show buttons WITH form when minimalStyle + showForm + modalButtonText (final CTA case)
            // Otherwise follow normal logic (buttons only when !showForm)
            var shouldShowButtons = this.props.minimalStyle && this.props.showForm && this.props.modalButtonText ? true : !this.props.showForm;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'new-form-wrapper ' + (this.props.inline || this.props.minimalStyle ? 'new-form-wrapper-b2b' : '') + ' ' + (this.props.ctaText ? 'same-width-buttons' : '') + ' ' + (this.props.darkBg ? 'dark-bg' : '') + ' ' + (this.props.fixedBottomBar ? 'demo-fixed-bottom' : '') + ' ' + (this.props.inlineBtns ? 'inline' : '') + ' ' + (this.props.newForm ? 'new-form-variant' : '') + ' ' + (this.props.buttonVariant === 'white' || this.props.buttonVariant === 'inverted-white' ? 'variant-white' : '') + ' ' + (this.props.className ? this.props.className : '') },
                    shouldShowButtons && this.props.newForm ? this.getNewFormButtons() : shouldShowButtons && this.props.trialButtonOnly ? _react2.default.createElement(
                        'button',
                        {
                            className: 'btn-green-shadow btn-modal',
                            onClick: function onClick(e) {
                                return _this15.openDemoModal(e);
                            },
                            title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                        },
                        this.props.modalButtonText || 'quero contratar'
                    ) : shouldShowButtons ? this.getTrialAndDemo() : null,
                    this.props.showForm ? _react2.default.createElement(
                        'div',
                        { className: 'show-full-form' },
                        this.props.inline || this.props.minimalStyle ? this.getInlineForm() : this.getForm()
                    ) : '',
                    this.state.showDemoModal && this.getDemoModal()
                )
            );
        }
    }]);

    return DemoForm;
}(_react.Component);

DemoForm.propTypes = {
    b2b: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    color: _propTypes2.default.string,
    contaAzul: _propTypes2.default.bool,
    partnerId: _propTypes2.default.string,
    modalSmall: _propTypes2.default.bool,
    trialButtonOnly: _propTypes2.default.bool,
    inline: _propTypes2.default.bool,
    newForm: _propTypes2.default.bool,
    buttonVariant: _propTypes2.default.oneOf(['default', 'inverted', 'white', 'inverted-white']),
    textAlign: _propTypes2.default.oneOf(['left', 'center', 'right']),
    ctaButtonText: _propTypes2.default.string,
    demoButtonText: _propTypes2.default.string,
    bottomText: _propTypes2.default.string,
    minimalStyle: _propTypes2.default.bool,
    showTrialLink: _propTypes2.default.bool,
    invertButtons: _propTypes2.default.bool,
    hideTitle: _propTypes2.default.bool,
    formHeroStyle: _propTypes2.default.bool,
    replaceTrialWithWhatsapp: _propTypes2.default.bool,
    whatsappButtonText: _propTypes2.default.string,
    whatsappBottomText: _propTypes2.default.string
};
DemoForm.defaultProps = {
    b2b: false,
    contaAzul: false,
    trialButtonOnly: false,
    inline: false,
    newForm: true,
    buttonVariant: 'default',
    textAlign: 'center',
    ctaButtonText: 'Faça um teste grátis',
    demoButtonText: 'Peça uma demonstração',
    bottomText: 'Teste grátis por 7 dias | Sem cobrança automática',
    minimalStyle: false,
    showTrialLink: false,
    invertButtons: false,
    hideTitle: false,
    formHeroStyle: false,
    replaceTrialWithWhatsapp: false,
    whatsappButtonText: 'Fale conosco no WhatsApp',
    whatsappBottomText: ''
};
exports.default = DemoForm;

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(534);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Paragraph = function Paragraph(_ref) {
    var center = _ref.center,
        children = _ref.children,
        className = _ref.className,
        gray = _ref.gray,
        italic = _ref.italic,
        left = _ref.left,
        _onClick = _ref.onClick,
        small = _ref.small,
        white = _ref.white;
    return _react2.default.createElement(
        'p',
        { className: (0, _classnames2.default)('paragraph', className, center && 'text-center', gray && 'heading-gray', italic && 'italic', left && 'text-left', small && 'small', white && 'heading-white'),
            onClick: function onClick(e) {
                return _onClick ? _onClick(e) : null;
            } },
        children
    );
};

exports.default = Paragraph;

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = NewFooter;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(545);

var _Utm = __webpack_require__(532);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NewFooter() {
    var accessLinks = [{ name: 'Entrar', url: 'https://app.mercos.com/login/', redirect: true }, { name: 'Cadastre-se', url: 'https://app.mercos.com/cadastro/', redirect: true }];

    var footerRows = [[{
        title: 'Soluções',
        links: [{ name: 'Força de vendas', url: '/forca-vendas/' }, { name: 'E-commerce B2B', url: '/e-commerce-b2b/' }, { name: 'CRM', url: '/crm-de-vendas' }, { name: 'Mercos Pay', url: '/mercos-pay' }, { name: 'Videochamada', url: '/videochamada/' }]
    }, {
        title: 'Recursos',
        links: [{ name: 'Aplicativo de vendas', url: '/aplicativo-vendas/' }, { name: 'Indicadores de vendas', url: '/recursos/indicadores-performance/' }, { name: 'Políticas comerciais', url: '/recursos/politica-comercial-vendas/' }, { name: 'Mercos IA', url: '/recursos/mercos-ia/' }]
    }, {
        title: 'Conteúdo',
        links: [{ name: 'Blog', url: 'https://blog.mercos.com/', external: true }, { name: 'Mercoscast', url: 'https://www.youtube.com/playlist?list=PLjAquKgGC5hWUNcPIdp4bntu9zcQLwTYI', external: true }, { name: _react2.default.createElement(
                _react2.default.Fragment,
                null,
                'E-commerce B2B: O',
                _react2.default.createElement('br', null),
                'que \xE9?'
            ), url: 'https://blog.mercos.com/e-commerce-b2b-o-que-e', target: '_blank', external: true }]
    }, {
        title: 'Transparência',
        links: [{ name: 'Termos e Condições', url: '/termos-e-condicoes/', target: '_blank' }, { name: 'Aviso de privacidade', url: '/aviso-de-privacidade/', target: '_blank' }, { name: 'Portal da Privacidade', url: 'https://www.privacidade.com.br/portal-de-privacidade/?token=511f11a2aed639b807ca96fea6935b2a&site_url=https://mercos.com/', target: '_blank', external: true }, { name: 'Relatório da igualdade salarial', url: '/relatorio-igualdade-salarial/' }]
    }, {
        title: 'Suporte',
        links: [{ name: 'Central de ajuda', url: 'https://ajuda.mercos.com/portal/pt-br/kb', external: true }, {
            custom: true,
            content: _react2.default.createElement(
                'div',
                { className: 'support-info' },
                _react2.default.createElement(
                    'div',
                    { className: 'support-phone' },
                    '(47) 3481.8050'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'support-hours' },
                    'Atendimento de Segunda',
                    _react2.default.createElement('br', null),
                    'a Quinta das 9h \xE0s 17h.',
                    _react2.default.createElement('br', null),
                    'Sexta das 9h30 \xE0s 17h.'
                )
            )
        }]
    }], [{
        title: 'Segmentos',
        links: [{ name: 'Indústrias', url: '/industrias/' }, { name: 'Distribuidoras', url: '/distribuidoras/' }, { name: 'Representantes', url: '/representantes-comerciais/' }]
    }, {
        title: 'Planos e preços',
        links: [{ name: 'Indústrias e distribuidoras', url: '/planos-e-precos/industrias-e-distribuidoras/' }, { name: 'Representantes', url: '/planos-e-precos/representantes/' }]
    }, {
        title: 'Institucional',
        links: [{ name: 'Carreira', url: 'https://mercos.gupy.io/' }, { name: 'Sobre Nós', url: '/sobre/' }]
    }, {
        title: 'Integrações',
        links: [{ name: 'ERPs integrados', url: '/integracao-erp/' }, { name: 'Seja Parceiro', url: '/parceiros' }, { name: 'Documentação da API', url: 'https://docs.mercos.com/', external: true }]
    }, {
        title: 'Baixe o aplicativo',
        content: _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                'div',
                { className: 'app-buttons' },
                _react2.default.createElement(
                    'a',
                    { href: 'https://apps.apple.com/br/app/mercos-app-de-vendas/id485511628', target: '_blank', rel: 'noopener noreferrer', className: 'app-button' },
                    _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/social/app-store.png', alt: 'Baixar na App Store' })
                ),
                _react2.default.createElement(
                    'a',
                    { href: 'https://play.google.com/store/apps/details?id=br.com.meuspedidos&hl=pt_BR', target: '_blank', rel: 'noopener noreferrer', className: 'app-button' },
                    _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/social/google-play.png', alt: 'Dispon\xEDvel no Google Play' })
                )
            ),
            _react2.default.createElement(
                'p',
                { className: 'app-downloads' },
                _react2.default.createElement(
                    'strong',
                    null,
                    '+100 mil'
                ),
                ' downloads'
            )
        )
    }]];

    var renderLink = function renderLink(link) {
        var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'footer-link';

        if (link.custom) return link.content;
        var target = link.target || (link.external ? '_blank' : null);

        return _react2.default.createElement(
            'a',
            {
                className: className,
                href: link.redirect ? null : link.url,
                onClick: link.redirect ? function () {
                    return (0, _Utm.redirectWithCookies)(link.url);
                } : null,
                target: target,
                rel: target === '_blank' ? 'noopener noreferrer' : null
            },
            link.name,
            link.external && _react2.default.createElement(
                'span',
                { className: 'material-icons site-footer__external-icon', 'aria-hidden': 'true' },
                'north_east'
            )
        );
    };

    var socialLinks = [{ name: 'LinkedIn', url: 'https://www.linkedin.com/company/mercos/mycompany/', icon: '/images/site/social/linkedin.svg' }, { name: 'Instagram', url: 'https://www.instagram.com/mercosoficial/', icon: '/images/site/social/instagram.svg' }, { name: 'Facebook', url: 'https://www.facebook.com/mercosoficial', icon: '/images/site/social/facebook.svg' }, { name: 'YouTube', url: 'https://www.youtube.com/channel/UCBcUDhuM1--cYwhP39dbEFw', icon: '/images/site/social/youtube.svg' }, { name: 'Spotify', url: 'https://open.spotify.com/show/5HpzDJ8q32r29HoZtVzGi1', icon: '/images/site/social/spotify.svg' }];

    return _react2.default.createElement(
        'footer',
        { className: 'mercos-footer site-footer', 'aria-label': 'Rodap\xE9' },
        _react2.default.createElement(
            'div',
            { className: 'footer-content site-footer__inner' },
            _react2.default.createElement(
                'div',
                { className: 'site-footer__access' },
                _react2.default.createElement(
                    'p',
                    { className: 'site-footer__access-txt' },
                    'J\xE1 \xE9 cliente ou quer come\xE7ar?'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'site-footer__access-actions' },
                    accessLinks.map(function (link, index) {
                        return _react2.default.createElement(
                            _react2.default.Fragment,
                            { key: link.url },
                            renderLink(link, 'site-footer__access-btn site-footer__access-btn--' + (index === 0 ? 'login' : 'signup'))
                        );
                    })
                )
            ),
            _react2.default.createElement(
                'nav',
                { className: 'footer-main site-footer__nav', 'aria-label': 'Links do rodap\xE9' },
                footerRows.map(function (row, rowIndex) {
                    return _react2.default.createElement(
                        'div',
                        { className: 'site-footer__nav-row', key: rowIndex },
                        row.map(function (section) {
                            return _react2.default.createElement(
                                'section',
                                { className: 'footer-section site-footer__section', key: section.title },
                                _react2.default.createElement(
                                    'p',
                                    { className: 'section-title site-footer__col-title' },
                                    section.title
                                ),
                                section.content || _react2.default.createElement(
                                    'div',
                                    { className: 'section-links site-footer__links' },
                                    section.links.map(function (link, linkIndex) {
                                        return _react2.default.createElement(
                                            'div',
                                            { className: 'link-item', key: link.url || linkIndex },
                                            renderLink(link, 'footer-link site-footer__link')
                                        );
                                    })
                                )
                            );
                        })
                    );
                })
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'footer-bottom site-footer__bar' },
            _react2.default.createElement(
                'div',
                { className: 'footer-container site-footer__bar-inner' },
                _react2.default.createElement(
                    'div',
                    { className: 'logo-container' },
                    _react2.default.createElement(
                        'a',
                        { href: '/', className: 'mercos-logo site-footer__bar-logo-link' },
                        _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/mercos-nuvini.svg', alt: 'Mercos - uma empresa nuvini' })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'company-info site-footer__legal' },
                    _react2.default.createElement(
                        'div',
                        null,
                        '\xA9 ',
                        new Date().getFullYear(),
                        ' Simplest Software Ltda. Todos os direitos reservados.'
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        'CNPJ: 12.496.510/0001-80 \xB7 Av. Rolf Wiest, 277 (4\xBA andar) \xB7 Bom Retiro \u2014 Joinville/SC \xB7 CEP: 89223-005'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'social-links site-footer__social' },
                    socialLinks.map(function (social) {
                        return _react2.default.createElement(
                            'a',
                            {
                                key: social.name,
                                href: social.url,
                                target: '_blank',
                                rel: 'noopener noreferrer',
                                className: 'social-link site-footer__social-link',
                                'aria-label': social.name
                            },
                            _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: social.icon, alt: 'Mercos no ' + social.name })
                        );
                    }),
                    _react2.default.createElement(
                        'span',
                        { className: 'feito-com-amor site-footer__made' },
                        'Feito com \uD83D\uDC9C'
                    )
                )
            )
        )
    );
}

/***/ }),

/***/ 545:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(550);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = function Input(_ref) {
    var placeholder = _ref.placeholder,
        onChange = _ref.onChange,
        id = _ref.id,
        error = _ref.error,
        value = _ref.value,
        ariaLabel = _ref.ariaLabel,
        _ref$maxLength = _ref.maxLength,
        maxLength = _ref$maxLength === undefined ? '' : _ref$maxLength,
        model = _ref.model,
        autoFocus = _ref.autoFocus,
        size = _ref.size,
        _ref$radius = _ref.radius,
        radius = _ref$radius === undefined ? 'all-rounded' : _ref$radius,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'text' : _ref$type,
        name = _ref.name;
    return _react2.default.createElement('input', { className: (0, _classnames2.default)('input', error && 'error', model, size, radius),
        'aria-label': ariaLabel,
        autoFocus: autoFocus,
        id: id,
        maxLength: maxLength,
        onChange: onChange,
        placeholder: placeholder,
        type: type,
        value: value,
        name: name || id
    });
};

Input.propTypes = {
    id: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    error: _propTypes2.default.bool,
    value: _propTypes2.default.string,
    ariaLabel: _propTypes2.default.string,
    maxLength: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    autoFocus: _propTypes2.default.bool,
    model: _propTypes2.default.oneOf(['outline', 'no-borders', 'secondary', 'success', 'alert', 'warning']),
    size: _propTypes2.default.string,
    radius: _propTypes2.default.oneOf(['half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded'])
};

exports.default = Input;

/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(114);

__webpack_require__(548);

var _Utm = __webpack_require__(532);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _siteNavData = __webpack_require__(549);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var renderItemTitle = function renderItemTitle(title) {
  if (typeof title === 'string') {
    return _react2.default.createElement(
      'h4',
      null,
      title
    );
  }
  return _react2.default.createElement(
    'h4',
    null,
    title
  );
};

var SiteNav = function SiteNav(_ref) {
  var _ref$hideOnScroll = _ref.hideOnScroll,
      hideOnScroll = _ref$hideOnScroll === undefined ? false : _ref$hideOnScroll,
      _ref$menuVisible = _ref.menuVisible,
      menuVisible = _ref$menuVisible === undefined ? true : _ref$menuVisible,
      _ref$pixelsToShowMenu = _ref.pixelsToShowMenuWhite,
      pixelsToShowMenuWhite = _ref$pixelsToShowMenu === undefined ? 50 : _ref$pixelsToShowMenu,
      _ref$transparentOnTop = _ref.transparentOnTop,
      transparentOnTop = _ref$transparentOnTop === undefined ? false : _ref$transparentOnTop,
      _ref$whiteBackground = _ref.whiteBackground,
      whiteBackground = _ref$whiteBackground === undefined ? false : _ref$whiteBackground,
      _ref$promoBarHeight = _ref.promoBarHeight,
      promoBarHeight = _ref$promoBarHeight === undefined ? 0 : _ref$promoBarHeight,
      _ref$loginOnly = _ref.loginOnly,
      loginOnly = _ref$loginOnly === undefined ? false : _ref$loginOnly,
      _ref$logoOnly = _ref.logoOnly,
      logoOnly = _ref$logoOnly === undefined ? false : _ref$logoOnly;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      activeMenu = _useState2[0],
      setActiveMenu = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isAtTop = _useState4[0],
      setIsAtTop = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      mobileMenuOpen = _useState6[0],
      setMobileMenuOpen = _useState6[1];

  var _useState7 = (0, _react.useState)({}),
      _useState8 = _slicedToArray(_useState7, 2),
      mobileOpenSections = _useState8[0],
      setMobileOpenSections = _useState8[1];

  var closeTimerRef = (0, _react.useRef)(null);
  var dropdownRefs = (0, _react.useRef)([]);

  var showTransparentTop = transparentOnTop && isAtTop && !whiteBackground && !mobileMenuOpen;

  var closeMobileMenu = (0, _react.useCallback)(function () {
    setMobileMenuOpen(false);
    setMobileOpenSections({});
  }, []);

  var toggleMobileMenu = function toggleMobileMenu() {
    if (mobileMenuOpen) {
      closeMobileMenu();
    } else {
      setMobileMenuOpen(true);
    }
  };

  var toggleMobileSection = function toggleMobileSection(index) {
    setMobileOpenSections(function (prev) {
      return _extends({}, prev, _defineProperty({}, index, !prev[index]));
    });
  };

  var closeAllDropdowns = function closeAllDropdowns() {
    return setActiveMenu(null);
  };

  var handleNavItemEnter = function handleNavItemEnter(index) {
    clearTimeout(closeTimerRef.current);
    setActiveMenu(index);

    var dd = dropdownRefs.current[index];
    if (!dd) return;

    dd.style.left = '';
    dd.style.right = '';

    requestAnimationFrame(function () {
      var rect = dd.getBoundingClientRect();
      var vw = window.innerWidth;
      if (rect.right > vw - 8) {
        var overflow = rect.right - (vw - 8);
        var currentLeft = parseFloat(window.getComputedStyle(dd).left) || 0;
        if (dd.style.right === '') {
          dd.style.left = currentLeft - overflow + 'px';
        }
      }
      if (rect.left < 8) {
        dd.style.left = '0px';
      }
    });
  };

  var handleNavItemLeave = function handleNavItemLeave(index) {
    closeTimerRef.current = setTimeout(function () {
      setActiveMenu(function (current) {
        return current === index ? null : current;
      });
    }, 100);
  };

  (0, _react.useEffect)(function () {
    var handleScroll = function handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsAtTop(scrollTop <= pixelsToShowMenuWhite);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [pixelsToShowMenuWhite]);

  (0, _react.useEffect)(function () {
    document.body.classList.toggle('mobile-menu-is-open', mobileMenuOpen);
    if (!mobileMenuOpen) {
      return undefined;
    }

    var onKeyDown = function onKeyDown(event) {
      if (event.key === 'Escape') {
        closeMobileMenu();
      }
    };

    document.addEventListener('keydown', onKeyDown);
    return function () {
      document.body.classList.remove('mobile-menu-is-open');
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [mobileMenuOpen, closeMobileMenu]);

  (0, _react.useEffect)(function () {
    var onDocumentClick = function onDocumentClick(event) {
      if (!event.target.closest('.site-nav__item')) {
        closeAllDropdowns();
      }
    };

    var onEscape = function onEscape(event) {
      if (event.key === 'Escape') {
        closeAllDropdowns();
      }
    };

    document.addEventListener('click', onDocumentClick);
    document.addEventListener('keydown', onEscape);

    return function () {
      document.removeEventListener('click', onDocumentClick);
      document.removeEventListener('keydown', onEscape);
      clearTimeout(closeTimerRef.current);
    };
  }, []);

  var navClassName = ['site-nav', hideOnScroll ? 'hide-on-scroll' : '', hideOnScroll && !menuVisible ? 'menu-hidden' : 'menu-visible', showTransparentTop ? 'at-top' : 'scrolled', promoBarHeight > 0 ? 'has-promo-bar' : '', mobileMenuOpen ? 'mobile-open' : '', logoOnly ? 'logo-only' : ''].filter(Boolean).join(' ');

  var menuItems = loginOnly ? [] : _siteNavData.siteNavData;

  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      _reactStatic.Head,
      null,
      _react2.default.createElement('link', { rel: 'stylesheet', href: 'https://fonts.googleapis.com/icon?family=Material+Icons' })
    ),
    _react2.default.createElement(
      'header',
      { className: navClassName, id: 'siteHeader' },
      _react2.default.createElement(
        'a',
        { href: '/', className: 'site-nav__logo', 'aria-label': 'Mercos' },
        _react2.default.createElement(_Picture2.default, {
          src: '/images/site/logo-mercos-colored.svg',
          alt: 'Mercos',
          className: 'site-nav__logo-img'
        })
      ),
      !loginOnly && !logoOnly && _react2.default.createElement(
        'nav',
        { className: 'site-nav__desktop', 'aria-label': 'Navega\xE7\xE3o principal' },
        _react2.default.createElement(
          'ul',
          { className: 'site-nav__menu' },
          menuItems.map(function (menuItem, idx) {
            return _react2.default.createElement(
              'li',
              {
                key: menuItem.label,
                className: 'site-nav__item' + (activeMenu === idx ? ' open' : ''),
                onMouseEnter: function onMouseEnter() {
                  return handleNavItemEnter(idx);
                },
                onMouseLeave: function onMouseLeave() {
                  return handleNavItemLeave(idx);
                }
              },
              _react2.default.createElement(
                'button',
                {
                  type: 'button',
                  className: 'site-nav__trigger',
                  'aria-haspopup': 'true',
                  'aria-expanded': activeMenu === idx
                },
                menuItem.label
              ),
              _react2.default.createElement(
                'div',
                {
                  ref: function ref(el) {
                    dropdownRefs.current[idx] = el;
                  },
                  className: 'site-nav__dropdown' + (menuItem.grid ? ' site-nav__dropdown--grid' : ''),
                  role: 'menu'
                },
                menuItem.items.map(function (item, subIdx) {
                  if (item.type === 'separator') {
                    return _react2.default.createElement(
                      'div',
                      { key: item.label + '-' + subIdx, className: 'site-nav__dd-label' },
                      item.label
                    );
                  }

                  return _react2.default.createElement(
                    'a',
                    {
                      key: item.link + '-' + subIdx,
                      href: item.link,
                      className: 'site-nav__dd-item',
                      role: 'menuitem',
                      target: item.target,
                      rel: item.target === '_blank' ? 'noopener noreferrer' : undefined
                    },
                    _react2.default.createElement(
                      'span',
                      { className: 'material-icons site-nav__dd-icon' },
                      item.icon
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'site-nav__dd-text' },
                      renderItemTitle(item.title),
                      item.description ? _react2.default.createElement(
                        'p',
                        null,
                        item.description
                      ) : null
                    )
                  );
                })
              )
            );
          })
        )
      ),
      !logoOnly && _react2.default.createElement(
        'div',
        { className: 'site-nav__actions' },
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'site-nav__cta',
            onClick: function onClick() {
              return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
            }
          },
          'comece gr\xE1tis'
        ),
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'site-nav__login',
            onClick: function onClick() {
              return (0, _Utm.redirectWithCookies)('https://app.mercos.com/login/');
            }
          },
          'Fazer login ',
          _react2.default.createElement(
            'span',
            { className: 'material-icons' },
            'chevron_right'
          )
        )
      ),
      !logoOnly && _react2.default.createElement(
        'button',
        {
          type: 'button',
          className: 'site-nav__mobile-cta',
          onClick: function onClick() {
            return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
          }
        },
        'comece gr\xE1tis'
      ),
      !logoOnly && _react2.default.createElement(
        'button',
        {
          type: 'button',
          className: 'site-nav__hamburger' + (mobileMenuOpen ? ' active' : ''),
          id: 'headerHamburger',
          'aria-label': mobileMenuOpen ? 'Fechar menu' : 'Abrir menu',
          'aria-expanded': mobileMenuOpen,
          'aria-controls': 'mobileNav',
          onClick: toggleMobileMenu
        },
        _react2.default.createElement('span', null),
        _react2.default.createElement('span', null),
        _react2.default.createElement('span', null)
      )
    ),
    !logoOnly && _react2.default.createElement(
      'nav',
      {
        className: 'site-nav__mobile' + (mobileMenuOpen ? ' active' : ''),
        id: 'mobileNav',
        'aria-label': 'Menu mobile',
        'aria-hidden': !mobileMenuOpen
      },
      menuItems.map(function (menuItem, idx) {
        return _react2.default.createElement(
          'div',
          {
            key: menuItem.label,
            className: 'site-nav__mob-section' + (mobileOpenSections[idx] ? ' open' : '')
          },
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'site-nav__mob-toggle',
              onClick: function onClick() {
                return toggleMobileSection(idx);
              }
            },
            menuItem.label,
            _react2.default.createElement(
              'span',
              { className: 'material-icons' },
              'expand_more'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'site-nav__mob-items' },
            _react2.default.createElement(
              'div',
              { className: 'site-nav__mob-items-inner' },
              menuItem.items.map(function (item, subIdx) {
                if (item.type === 'separator') {
                  return _react2.default.createElement(
                    'div',
                    { key: item.label + '-' + subIdx, className: 'site-nav__mob-label' },
                    item.label
                  );
                }

                return _react2.default.createElement(
                  'a',
                  {
                    key: item.link + '-' + subIdx,
                    href: item.link,
                    className: 'site-nav__mob-item',
                    target: item.target,
                    rel: item.target === '_blank' ? 'noopener noreferrer' : undefined,
                    onClick: closeMobileMenu
                  },
                  _react2.default.createElement(
                    'span',
                    { className: 'material-icons' },
                    item.icon
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    renderItemTitle(item.title),
                    item.description ? _react2.default.createElement(
                      'p',
                      null,
                      item.description
                    ) : null
                  )
                );
              })
            )
          )
        );
      }),
      _react2.default.createElement(
        'div',
        { className: 'site-nav__mob-actions' },
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'site-nav__mob-actions-cta',
            onClick: function onClick() {
              return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
            }
          },
          'comece gr\xE1tis'
        ),
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'site-nav__mob-actions-login',
            onClick: function onClick() {
              return (0, _Utm.redirectWithCookies)('https://app.mercos.com/login/');
            }
          },
          'Fazer login ',
          _react2.default.createElement(
            'span',
            { className: 'material-icons' },
            'chevron_right'
          )
        )
      )
    )
  );
};

exports.default = SiteNav;

/***/ }),

/***/ 548:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.siteNavData = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var siteNavData = exports.siteNavData = [{
  label: 'Soluções',
  items: [{
    title: 'Força de vendas',
    description: '+25 indicadores e +30 relatórios para gerenciar sua equipe',
    icon: 'bar_chart',
    link: '/forca-vendas/'
  }, {
    title: 'E-commerce B2B',
    description: 'Venda 24h por dia com a loja online de empresas para empresas',
    icon: 'shopping_cart',
    link: '/e-commerce-b2b'
  }, {
    type: 'separator',
    label: 'Outras Soluções'
  }, {
    title: 'CRM',
    description: 'Cuide da prospecção ao pós-venda dos clientes em um só lugar',
    icon: 'filter_alt',
    link: '/crm-de-vendas'
  }, {
    title: 'Mercos Pay',
    description: 'Receba pagamentos por pix, boleto e cartões de crédito',
    icon: 'credit_card',
    link: '/mercos-pay'
  }, {
    title: 'Videochamada',
    description: 'Venda por vídeo com experiência de visita presencial',
    icon: 'videocam',
    link: '/videochamada'
  }]
}, {
  label: 'Segmentos',
  items: [{
    title: 'Indústrias',
    description: 'Automatize vendas, conecte canais e escale seu negócio com inteligência',
    icon: 'factory',
    link: '/sistema-para-industria/'
  }, {
    title: 'Distribuidoras',
    description: 'Gerencie clientes e pedidos, vendas automatizadas e integração total',
    icon: 'home_work',
    link: '/sistema-distribuidora/'
  }, {
    title: 'Representantes',
    description: 'Crie e gerencie políticas comerciais para cada cliente e representada',
    icon: 'work',
    link: '/sistema-representante/'
  }]
}, {
  label: 'Planos e preços',
  items: [{
    title: _react2.default.createElement(
      _react.Fragment,
      null,
      'Planos para ',
      _react2.default.createElement(
        'strong',
        null,
        'Ind\xFAstrias e distribuidoras'
      )
    ),
    description: '',
    icon: 'factory',
    link: '/planos-e-precos/industrias-e-distribuidoras/'
  }, {
    title: _react2.default.createElement(
      _react.Fragment,
      null,
      'Planos para ',
      _react2.default.createElement(
        'strong',
        null,
        'Representantes'
      )
    ),
    description: '',
    icon: 'work',
    link: '/planos-e-precos/representantes/'
  }]
}, {
  label: 'Integrações',
  items: [{
    title: 'ERPs integrados',
    description: '+250 ERPs parceiros integrados ao Força de vendas e E-commerce B2B',
    icon: 'device_hub',
    link: '/integracao-erp'
  }, {
    title: 'Seja Parceiro',
    description: 'Seja um Mpartner e leve seu negócio ao próximo nível',
    icon: 'people',
    link: '/parceiros'
  }]
}, {
  label: 'Recursos',
  grid: true,
  items: [{
    title: 'Aplicativo de vendas',
    description: 'Emita pedidos até sem internet e agilize a rotina do seu time comercial.',
    icon: 'smartphone',
    link: '/recursos/aplicativo-vendas-externas/'
  }, {
    title: 'Mercos IA',
    description: 'Inteligência Artificial na palma da sua mão',
    icon: 'auto_awesome',
    link: '/recursos/mercos-ia/'
  }, {
    title: 'Indicadores de vendas',
    description: 'Visualize a performance do seu comercial em tempo real e tome decisões mais rápidas.',
    icon: 'show_chart',
    link: '/recursos/indicadores-performance/'
  }, {
    title: 'Materiais ricos',
    description: 'Ebooks e guias para turbinar sua estratégia de vendas B2B.',
    icon: 'menu_book',
    link: '/materiais/'
  }, {
    title: 'Políticas comerciais',
    description: 'Aplique regras de preço, desconto e acréscimo sem erro – tudo de forma automática.',
    icon: 'flag',
    link: '/recursos/politica-comercial-vendas/'
  }, {
    title: 'Cases',
    description: 'Veja cases de sucesso e inspire melhores resultados para sua empresa.',
    icon: 'rocket_launch',
    link: 'https://mercos.com/cases/'
  }]
}];

/***/ }),

/***/ 550:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SiteNav = __webpack_require__(547);

var _SiteNav2 = _interopRequireDefault(_SiteNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SiteNav2.default;

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(553);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TESTIMONIALS = [{
    testimonial: "“Imagine a nossa felicidade em ganhar produtividade, se adaptar ao mercado e às tendências. Não tem jeito, quem não faz isso perde grandes oportunidades”",
    author: "Alexandre Santos",
    company: "Delícia Lanches"
}, {
    testimonial: "“Tínhamos o desafio de dobrar o faturamento em 12 meses e conseguimos atingir essa meta em apenas 10. O software da Mercos foi crucial para isto.”",
    author: "Rafael A. Krause",
    company: "Grupo Herbia"
}, {
    testimonial: "“Meu Foco é ajudar clientes a fazer negócios, para isso uso tanto o presencial quanto a tecnologia como aliados”",
    author: "Felipe Rodrigues",
    company: "IF Consultoria e Representação"
}, {
    testimonial: "“Essencial para qualquer representante que quer crescer. Toda minha equipe usa Mercos, melhoramos o atendimento e aumentarmos nosso volume de vendas.”",
    author: "Afonso Tonelli",
    company: "Musical Plus Representações"
}];
var TESTIMONIALS2 = [{
    testimonial: "“Desconheço software de vendas igual. Com Mercos elevamos o faturamento em mais 300% em menos de 3 anos.”",
    author: "Gustavo Ribeiro",
    company: "Impacttus Cosméticos"
}, {
    testimonial: "“Passamos a prospectar e vender, além do presencial, 24 horas e 7 dias da semana para os clientes! Nosso intuito era vender além do território que atingíamos com as vendas externas. E foi isso que começamos a fazer, em pouquíssimo tempo!”",
    author: "Alan Alves",
    company: "Almmati"
}, {
    testimonial: "“Minha melhor experiência com a Mercos, é a facilidade que ele me dá na rua. A dinâmica que eu tenho e o volume de informações que eu consigo, isso me facilita muito!”",
    author: "Cristiano Oliveira",
    company: "Representante Comercial Harman"
}];

var ModalTestimonials = function (_Component) {
    _inherits(ModalTestimonials, _Component);

    function ModalTestimonials() {
        _classCallCheck(this, ModalTestimonials);

        return _possibleConstructorReturn(this, (ModalTestimonials.__proto__ || Object.getPrototypeOf(ModalTestimonials)).apply(this, arguments));
    }

    _createClass(ModalTestimonials, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'modal-testimonials' },
                _react2.default.createElement(
                    'div',
                    { className: 'testimonials-col' },
                    TESTIMONIALS.map(function (testimonial) {
                        return _react2.default.createElement(
                            'div',
                            { className: 'modal-testimonial-box' },
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-text' },
                                testimonial.testimonial
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-name' },
                                testimonial.author
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-company' },
                                testimonial.company
                            )
                        );
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'testimonials-col testimonials-col2' },
                    TESTIMONIALS2.map(function (testimonial) {
                        return _react2.default.createElement(
                            'div',
                            { className: 'modal-testimonial-box' },
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-text' },
                                testimonial.testimonial
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-name' },
                                testimonial.author
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-company' },
                                testimonial.company
                            )
                        );
                    })
                )
            );
        }
    }]);

    return ModalTestimonials;
}(_react.Component);

exports.default = ModalTestimonials;

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _jsCookie = __webpack_require__(174);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _Button = __webpack_require__(533);

var _Button2 = _interopRequireDefault(_Button);

var _Modal = __webpack_require__(535);

var _Modal2 = _interopRequireDefault(_Modal);

var _InputFloatingLabel = __webpack_require__(541);

var _InputFloatingLabel2 = _interopRequireDefault(_InputFloatingLabel);

var _RDGateway = __webpack_require__(175);

var _RDGateway2 = _interopRequireDefault(_RDGateway);

var _masks = __webpack_require__(537);

var _Utm = __webpack_require__(532);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FIELDS = ['name', 'email', 'telephone', 'activity'];

var ACTIVITY = {
    industria: 'Indústria',
    distribuicao: 'Distribuição',
    rep: 'Representação Comercial',
    outra: 'Outro'
};

var USERS = {
    um: '1',
    cinco: '2-5',
    vinte: '6-20',
    cinquenta: '21-50',
    cinquentaum: '51 ou mais'
};

var DemoFormB2B = function (_Component) {
    _inherits(DemoFormB2B, _Component);

    function DemoFormB2B(props) {
        _classCallCheck(this, DemoFormB2B);

        var _this = _possibleConstructorReturn(this, (DemoFormB2B.__proto__ || Object.getPrototypeOf(DemoFormB2B)).call(this, props));

        _this.handleActivityChange = function (activity) {
            _this.setState({ selectedActivity: activity });
        };

        _this.handleActivityDropdownClick = function (e) {
            var dropdown = e.currentTarget.nextElementSibling;
            var button = e.currentTarget;

            dropdown.classList.toggle('show');
            button.classList.toggle('expanded');
        };

        _this.handleUsersDropdownClick = function (e) {
            var dropdown = e.currentTarget.nextElementSibling;
            var button = e.currentTarget;

            dropdown.classList.toggle('show');
            button.classList.toggle('expanded');
        };

        _this.handleActivityOptionClick = function (activity) {
            var button = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown-button');
            var dropdown = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown');

            dropdown.classList.remove('show');
            button.classList.remove('expanded');
            button.classList.add('option-selected');
            button.textContent = activity;

            _this.handlerEnterpriseActivity(activity);
        };

        _this.handleUsersOptionClick = function (users) {
            var button = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown-button');
            var dropdown = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown');

            dropdown.classList.remove('show');
            button.classList.remove('expanded');
            button.classList.add('option-selected');
            button.textContent = users;

            _this.handlerUsers(users);
        };

        _this.rdGateway = new _RDGateway2.default();
        _this.state = _this.getInitialState(props);

        globalThis.optimizeOpenPopupB2B = function () {
            _this.setState({ showDemoModal: true });
        };
        return _this;
    }

    _createClass(DemoFormB2B, [{
        key: 'getInitialState',
        value: function getInitialState(props) {
            var initialObject = {
                showDemoModal: false,
                company: '',
                name: '',
                email: '',
                telephone: '',
                activity: '',
                users: '',
                partnerId: props.partnerId
            };
            var fields = props.showUsersField ? [].concat(FIELDS, ['users']) : FIELDS;
            fields.forEach(function (campo) {
                initialObject[campo + 'Error'] = false;
                initialObject[campo + 'Typing'] = false;
            });
            return initialObject;
        }
    }, {
        key: 'setDataByCookie',
        value: function setDataByCookie() {
            this.setState({
                partnerId: _jsCookie2.default.get('leaderPartnerId') || this.state.partnerId || ''
            });
        }
    }, {
        key: 'openDemoModal',
        value: function openDemoModal(e) {
            e.preventDefault();

            this.setState({
                showDemoModal: true
            });
        }
    }, {
        key: 'closeDemoModal',
        value: function closeDemoModal() {
            this.setState({
                showDemoModal: false
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var _setState;

            var name = e.target.id;
            var value = e.target.value;
            var company = this.state.name + ' - ' + this.state.email;

            if (name === 'telephone') {
                value = (0, _masks.telephoneMask)(value);
            } else if (name === 'name') {
                company = value + ' - ' + this.state.email;
            } else if (name === 'email') {
                company = this.state.name + ' - ' + value;
            }

            this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, 'company', company), _defineProperty(_setState, name + 'Error', false), _defineProperty(_setState, name + 'Typing', true), _setState));
        }
    }, {
        key: 'handlerEnterpriseActivity',
        value: function handlerEnterpriseActivity(tipo) {
            this.setState({ 'activity': tipo });
        }
    }, {
        key: 'handlerUsers',
        value: function handlerUsers(users) {
            this.setState({ 'users': users });
        }
    }, {
        key: 'getSelectedActivity',
        value: function getSelectedActivity(selected) {
            return this.state.activity === selected ? 'active' : '';
        }
    }, {
        key: 'getSelectedUsers',
        value: function getSelectedUsers(selected) {
            return this.state.users === selected ? 'active' : '';
        }
    }, {
        key: 'validation',
        value: function validation() {
            var _this2 = this;

            var newState = {};

            var regexTelephone = /^\([1-9]{2}\) [2-9][0-9]{3,4}\-[0-9]{4}$/;
            var fields = this.props.showUsersField ? [].concat(FIELDS, ['users']) : FIELDS;
            fields.forEach(function (campo) {
                newState[campo + 'Error'] = !_this2.state[campo];
                switch (campo) {
                    case 'email':
                        {
                            newState[campo + 'Error'] = !_this2.validateEmail(_this2.state[campo]);
                            break;
                        }
                    case 'telephone':
                        {
                            newState[campo + 'Error'] = !regexTelephone.test(_this2.state[campo]);
                            break;
                        }
                }
            });
            this.setState(newState);
            var lista = Object.values(newState);
            return lista.every(function (value) {
                return !value;
            });
        }
    }, {
        key: 'validateEmail',
        value: function validateEmail(email) {
            var regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return regexEmail.test(email.toLowerCase());
        }
    }, {
        key: 'submitForm',
        value: function submitForm(e) {
            e.preventDefault();
            if (this.validation()) {
                var data = {
                    conversion_identifier: 'fale-consultor-b2b',
                    'cf_tipo_de_conversao': 'Solicitou demonstração E-commerce B2B',
                    company_name: this.state.company,
                    name: this.state.name,
                    email: this.state.email,
                    personal_phone: this.state.telephone,
                    'cf_atividade_da_empresa': this.state.activity,
                    event_action: 'solicitou_demo',
                    event_label: 'ecommerce_b2b'
                };

                if (this.props.showUsersField) {
                    data['cf_numero_de_vendedores'] = this.state.users;
                }

                if (this.state.partnerId) {
                    data.conversion_identifier = 'canais-lp';
                    data['cf_codigo_do_parceiro_meus_pedidos'] = this.state.partnerId;
                }

                var redirectLink = 'https://mercos.com/tp/solicitou-demo-b2b/';
                if (this.state.activity === ACTIVITY.rep || this.state.activity === ACTIVITY.outra) {
                    redirectLink = 'https://materiais.mercos.com/tp-demo-b2b';
                } else if (this.props.euCommerce) {
                    redirectLink = 'https://mercos.com/tp/tp-parceria-mercos-eucommerce/';
                } else if (this.props.b2bPromo) {
                    redirectLink = 'https://materiais.mercos.com/tp-clientes-demo-b2b';
                }
                this.rdGateway.sendToRDStation(data, redirectLink);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setDataByCookie();
        }
    }, {
        key: 'getDemoModal',
        value: function getDemoModal() {
            var _this3 = this;

            return _react2.default.createElement(
                _Modal2.default,
                { callbackCloseModal: function callbackCloseModal() {
                        return _this3.closeDemoModal();
                    }, className: this.props.formHeroStyle ? 'form-hero-demo-modal' : undefined },
                _react2.default.createElement(
                    'div',
                    { className: 'container-form-modal' },
                    this.getForm()
                )
            );
        }
    }, {
        key: 'getForm',
        value: function getForm() {
            var _this4 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'form-container' },
                    !this.props.hideTitle && this.props.title === false ? null : !this.props.hideTitle ? _react2.default.createElement(
                        'div',
                        { className: 'form-title' },
                        this.props.title ? this.props.title : 'Preencha o formulário abaixo e solicite uma demonstração',
                        ' ',
                        this.props.euCommerce ? this.props.euCommerce : '',
                        ' ',
                        this.props.b2bPromo ? this.props.b2bPromo : ''
                    ) : null,
                    _react2.default.createElement(
                        'form',
                        { action: '.', method: 'POST', className: 'new-form', onSubmit: function onSubmit(e) {
                                return _this4.submitForm(e);
                            } },
                        this.props.formHeroStyle ? _react2.default.createElement('input', { type: 'hidden', name: 'company', value: this.state.company }) : _react2.default.createElement(_InputFloatingLabel2.default, { type: 'hidden', name: 'company', value: this.state.company }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                                return _this4.handleChange(e);
                            }, error: this.state.nameError, placeholder: this.props.formHeroStyle ? 'Nome completo' : 'Nome', inputPlaceholder: this.props.formHeroStyle ? 'Seu nome completo' : undefined }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this4.handleChange(e);
                            }, error: this.state.emailError, placeholder: 'E-mail profissional', inputPlaceholder: this.props.formHeroStyle ? 'seu@empresa.com.br' : undefined }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                                return _this4.handleChange(e);
                            }, error: this.state.telephoneError, maxLength: '15', placeholder: this.props.formHeroStyle ? 'Telefone / WhatsApp' : 'Telefone', inputPlaceholder: this.props.formHeroStyle ? '(00) 00000-0000' : undefined }),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleActivityDropdownClick },
                                'Selecione uma op\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                            return _this4.handleActivityOptionClick(ACTIVITY.industria);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-industrias.svg' }),
                                    'Ind\xFAstrias'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                            return _this4.handleActivityOptionClick(ACTIVITY.distribuicao);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-distribuidoras.svg' }),
                                    'Distribuidoras'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                            return _this4.handleActivityOptionClick(ACTIVITY.rep);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-representates.svg' }),
                                    'Representantes'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                            return _this4.handleActivityOptionClick(ACTIVITY.outra);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-outros.svg' }),
                                    'Outra'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                this.props.formHeroStyle ? 'Atividade da sua empresa' : 'Qual é a atividade da sua empresa?'
                            ),
                            this.state.activityError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        this.props.showUsersField && _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleUsersDropdownClick },
                                'Selecione uma op\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.um), onClick: function onClick() {
                                            return _this4.handleUsersOptionClick(USERS.um);
                                        } },
                                    '1'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.cinco), onClick: function onClick() {
                                            return _this4.handleUsersOptionClick(USERS.cinco);
                                        } },
                                    '2-5'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.vinte), onClick: function onClick() {
                                            return _this4.handleUsersOptionClick(USERS.vinte);
                                        } },
                                    '6-20'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.cinquenta), onClick: function onClick() {
                                            return _this4.handleUsersOptionClick(USERS.cinquenta);
                                        } },
                                    '21-50'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.cinquentaum), onClick: function onClick() {
                                            return _this4.handleUsersOptionClick(USERS.cinquentaum);
                                        } },
                                    '51 ou mais'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                'Quantidade de vendedores da sua empresa'
                            ),
                            this.state.usersError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', className: 'new-submit new-button' },
                                this.props.submitButtonText
                            )
                        ),
                        this.props.formHeroStyle && _react2.default.createElement(
                            'div',
                            { className: 'form-hero-footer' },
                            _react2.default.createElement(
                                'span',
                                null,
                                'Especialista dedicado'
                            ),
                            _react2.default.createElement('span', { className: 'form-hero-footer__dot', 'aria-hidden': 'true' }),
                            _react2.default.createElement(
                                'span',
                                null,
                                'Demonstra\xE7\xE3o personalizada'
                            )
                        ),
                        this.props.showTrialLink && _react2.default.createElement(
                            'div',
                            { className: 'trial-link-wrapper' },
                            _react2.default.createElement(
                                'span',
                                { className: 'trial-link-text' },
                                'ou '
                            ),
                            _react2.default.createElement(
                                'a',
                                {
                                    href: 'https://app.mercos.com/cadastro/',
                                    className: 'trial-link',
                                    onClick: function onClick(e) {
                                        e.preventDefault();
                                        (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                                    }
                                },
                                'Fa\xE7a um teste gr\xE1tis \u203A'
                            )
                        ),
                        (this.props.showForm || this.props.inline) && !this.props.showTrialLink && _react2.default.createElement(
                            'p',
                            { className: 'inline-form-trial-info' },
                            'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a autom\xE1tica'
                        ),
                        this.props.showTrialLink && _react2.default.createElement(
                            'p',
                            { className: 'inline-form-trial-info' },
                            'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a autom\xE1tica'
                        )
                    )
                )
            );
        }
    }, {
        key: 'getCTA',
        value: function getCTA() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'cta-button-form' },
                    this.getModalButton(),
                    _react2.default.createElement(
                        'p',
                        { className: 'font-light font-12' },
                        'integra\xE7\xE3o com mais de 200 ERPs ',
                        _react2.default.createElement(
                            'span',
                            { className: 'cta-text-separator' },
                            '| '
                        ),
                        'venda 24h por dia, 7 dias por semana ',
                        _react2.default.createElement(
                            'span',
                            { className: 'cta-text-separator' },
                            '| '
                        ),
                        'simples de usar'
                    )
                )
            );
        }
    }, {
        key: 'getModalButton',
        value: function getModalButton() {
            var _this5 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'button',
                    {
                        href: '.',
                        className: 'new-button  ' + (this.props.trialAndDemo ? 'button-secondary' : 'button-primary'),
                        onClick: function onClick(e) {
                            return _this5.openDemoModal(e);
                        },
                        title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                    },
                    this.props.modalButtonText || this.props.children || 'peça uma demonstração'
                ),
                this.props.buttonOnly && _react2.default.createElement(
                    'p',
                    { className: 'button-only-trial-info' },
                    'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a autom\xE1tica'
                )
            );
        }
    }, {
        key: 'getModalLink',
        value: function getModalLink() {
            var _this6 = this;

            return _react2.default.createElement(
                'a',
                {
                    href: '.',
                    className: 'button-txt ' + (this.props.darkBg ? 'button-txt-white' : ''),
                    onClick: function onClick(e) {
                        return _this6.openDemoModal(e);
                    },
                    title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                },
                this.props.modalButtonText || 'conheça o E-commerce B2B ›'
            );
        }
    }, {
        key: 'getTrialAndDemo',
        value: function getTrialAndDemo() {
            var _this7 = this;

            var demoButtonClass = this.props.invertButtons ? 'button-primary' : 'button-secondary';
            var trialButtonClass = this.props.invertButtons ? 'button-secondary' : 'button-primary';

            return _react2.default.createElement(
                'div',
                { className: 'wrapper-trial-and-demo mobile-only' },
                _react2.default.createElement(
                    'button',
                    {
                        className: 'new-button ' + demoButtonClass + ' ' + (this.props.darkBg ? 'dark-bg' : ''),
                        onClick: function onClick(e) {
                            return _this7.openDemoModal(e);
                        },
                        title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                    },
                    this.props.modalButtonText || 'peça uma demonstração'
                ),
                _react2.default.createElement(
                    'button',
                    {
                        className: 'new-button ' + trialButtonClass + ' ' + (this.props.darkBg ? 'dark-bg' : ''),
                        onClick: function onClick() {
                            return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                        },
                        href: '#',
                        title: 'Cadastre-se no Mercos!'
                    },
                    this.props.trialAndDemo
                ),
                this.props.invertButtons && _react2.default.createElement(
                    'p',
                    { className: 'trial-info-text' },
                    'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a autom\xE1tica'
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'new-form-wrapper new-form-wrapper-b2b' },
                    this.props.modaLink ? this.getModalLink() : this.props.trialAndDemo ? this.getTrialAndDemo() : this.props.buttonOnly ? this.getModalButton() : this.getCTA(),
                    this.props.showForm && _react2.default.createElement(
                        'div',
                        { className: 'show-full-form' },
                        this.getForm()
                    ),
                    this.state.showDemoModal && this.getDemoModal()
                )
            );
        }
    }]);

    return DemoFormB2B;
}(_react.Component);

DemoFormB2B.propTypes = {
    b2b: _propTypes2.default.bool,
    contaAzul: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    radius: _propTypes2.default.string,
    partnerId: _propTypes2.default.string,
    buttonOnly: _propTypes2.default.bool,
    modalButtonText: _propTypes2.default.string,
    hideTitle: _propTypes2.default.bool,
    submitButtonText: _propTypes2.default.string,
    showTrialLink: _propTypes2.default.bool,
    invertButtons: _propTypes2.default.bool,
    showUsersField: _propTypes2.default.bool,
    formHeroStyle: _propTypes2.default.bool
};
DemoFormB2B.defaultProps = {
    b2b: false,
    contaAzul: false,
    radius: 'half-rounded',
    buttonOnly: false,
    hideTitle: false,
    submitButtonText: 'Solicitar demonstração',
    showTrialLink: false,
    invertButtons: false,
    showUsersField: true,
    formHeroStyle: false
};
exports.default = DemoFormB2B;

/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Constants for Mercos site numbers
// Centralized place to manage all the client numbers and revenue figures

var SITE_CONSTANTS = exports.SITE_CONSTANTS = {
  // Client numbers (updated to 9 mil)
  CLIENTS_COUNT: '9 mil',
  CLIENTS_COUNT_WITH_PLUS: '+9 mil',
  CLIENTS_COUNT_DETAILED: '9.000',
  CLIENTS_COUNT_WITH_COMMA: '9 mil',

  // Revenue (updated to 100 bi)
  ANNUAL_REVENUE: 'R$ 100 BI',
  ANNUAL_REVENUE_LOWERCASE: 'R$ 100 bi',

  // App ratings
  GOOGLE_PLAY_RATING: '4,9',
  GOOGLE_PLAY_REVIEWS: '7 mil avaliações',
  APP_STORE_RATING: '4,8',
  APP_STORE_REVIEWS: '2,8 mil avaliações',
  GOOGLE_BUSINESS_RATING: '4,6',
  GOOGLE_BUSINESS_REVIEWS: '701 avaliações',

  // Other numbers that might be used
  USERS_COUNT: '+52 mil',
  USERS_COUNT_DETAILED: '56.000',
  ERPS_INTEGRATED: '+250',
  ANNUAL_ORDERS: '+ 14 MI'

  // Helper functions to get formatted numbers
};var getClientsCount = exports.getClientsCount = function getClientsCount() {
  var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';

  switch (format) {
    case 'plus':
      return SITE_CONSTANTS.CLIENTS_COUNT_WITH_PLUS;
    case 'detailed':
      return SITE_CONSTANTS.CLIENTS_COUNT_DETAILED;
    case 'comma':
      return SITE_CONSTANTS.CLIENTS_COUNT_WITH_COMMA;
    default:
      return SITE_CONSTANTS.CLIENTS_COUNT;
  }
};

var getRevenue = exports.getRevenue = function getRevenue() {
  var lowercase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  return lowercase ? SITE_CONSTANTS.ANNUAL_REVENUE_LOWERCASE : SITE_CONSTANTS.ANNUAL_REVENUE;
};

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

__webpack_require__(564);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_HELP_ICON = "/images/site/landing-pages/segmentos/help.svg";
var DEFAULT_ARROW_ICON = "/images/site/landing-pages/segmentos/keyboard-arrow-down.svg";

var UnifiedFAQ = function UnifiedFAQ(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === undefined ? "Perguntas frequentes" : _ref$title,
      subtitle = _ref.subtitle,
      _ref$faqItems = _ref.faqItems,
      faqItems = _ref$faqItems === undefined ? [] : _ref$faqItems,
      _ref$defaultOpenIndex = _ref.defaultOpenIndex,
      defaultOpenIndex = _ref$defaultOpenIndex === undefined ? 0 : _ref$defaultOpenIndex,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? "" : _ref$className,
      titleId = _ref.titleId,
      _ref$titleTag = _ref.titleTag,
      TitleTag = _ref$titleTag === undefined ? "h2" : _ref$titleTag,
      _ref$questionTag = _ref.questionTag,
      QuestionTag = _ref$questionTag === undefined ? "span" : _ref$questionTag,
      _ref$helpIconSrc = _ref.helpIconSrc,
      helpIconSrc = _ref$helpIconSrc === undefined ? DEFAULT_HELP_ICON : _ref$helpIconSrc,
      _ref$arrowIconSrc = _ref.arrowIconSrc,
      arrowIconSrc = _ref$arrowIconSrc === undefined ? DEFAULT_ARROW_ICON : _ref$arrowIconSrc;

  var _useState = (0, _react.useState)(defaultOpenIndex),
      _useState2 = _slicedToArray(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var headingId = titleId || "faq-title-" + title.toLowerCase().replace(/[^a-z0-9]+/g, "-");

  if (!faqItems.length) {
    return null;
  }

  var toggleItem = function toggleItem(index) {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return _react2.default.createElement(
    "section",
    { className: ("unified-faq faq-section " + className).trim(), "aria-labelledby": headingId },
    _react2.default.createElement(
      "div",
      { className: "faq-content" },
      _react2.default.createElement(
        "div",
        { className: "faq-header" },
        _react2.default.createElement(
          "div",
          { className: "faq-header__icon-wrap" },
          _react2.default.createElement(_Picture2.default, { src: helpIconSrc, alt: "", "aria-hidden": "true" })
        ),
        _react2.default.createElement(
          "div",
          { className: "faq-header__text-col" },
          _react2.default.createElement(
            TitleTag,
            { className: "faq-header__title", id: headingId },
            title
          ),
          subtitle && _react2.default.createElement(
            "div",
            { className: "faq-header__subtitle" },
            subtitle
          )
        )
      ),
      _react2.default.createElement(
        "ul",
        { className: "faq-accordion" },
        faqItems.map(function (item, index) {
          var isOpen = activeIndex === index;
          var answerId = headingId + "-answer-" + (index + 1);

          return _react2.default.createElement(
            "li",
            { className: "faq-item " + (isOpen ? "faq-item--open" : ""), key: item.question },
            _react2.default.createElement(
              "button",
              {
                className: "faq-item__btn",
                type: "button",
                "aria-expanded": isOpen,
                "aria-controls": answerId,
                onClick: function onClick() {
                  return toggleItem(index);
                }
              },
              _react2.default.createElement(
                QuestionTag,
                { className: "faq-item__question" },
                item.question
              ),
              _react2.default.createElement(_Picture2.default, { className: "faq-item__arrow", src: arrowIconSrc, alt: "", "aria-hidden": "true" })
            ),
            _react2.default.createElement(
              "div",
              { className: "faq-item__answer", id: answerId },
              _react2.default.createElement(
                "div",
                { className: "faq-item__answer-inner" },
                typeof item.answer === "string" ? _react2.default.createElement(
                  "p",
                  null,
                  item.answer
                ) : item.answer
              )
            )
          );
        })
      )
    )
  );
};

exports.default = UnifiedFAQ;

/***/ }),

/***/ 564:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _DemoForm = __webpack_require__(542);

var _DemoForm2 = _interopRequireDefault(_DemoForm);

var _DemoFormB2B = __webpack_require__(554);

var _DemoFormB2B2 = _interopRequireDefault(_DemoFormB2B);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

__webpack_require__(570);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FinalCTACard = function FinalCTACard(_ref) {
    var title = _ref.title,
        description = _ref.description,
        buttonVariant = _ref.buttonVariant,
        useB2BForm = _ref.useB2BForm,
        useMinimalStyle = _ref.useMinimalStyle,
        useWhatsAppStyle = _ref.useWhatsAppStyle,
        submitButtonText = _ref.submitButtonText,
        modalButtonText = _ref.modalButtonText,
        trialAndDemo = _ref.trialAndDemo,
        showTrialLink = _ref.showTrialLink,
        showTrialInfo = _ref.showTrialInfo,
        _ref$titleTag = _ref.titleTag,
        titleTag = _ref$titleTag === undefined ? 'h4' : _ref$titleTag;

    var TitleTag = titleTag;

    return _react2.default.createElement(
        'div',
        { className: 'final-cta-card-section' },
        _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
                'div',
                { className: 'cta-card' },
                _react2.default.createElement(
                    'div',
                    { className: 'cta-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'cta-text' },
                        _react2.default.createElement(
                            TitleTag,
                            { className: 'cta-title' },
                            title || 'Peça uma demonstração e fale com um de nossos especialistas pelo Whatsapp'
                        ),
                        _react2.default.createElement(
                            'p',
                            null,
                            description || 'Ainda com dúvidas? Clique abaixo, cadastre seus dados e fale diretamente com nosso time de especialistas!'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'cta-button' },
                        useWhatsAppStyle ? _react2.default.createElement(_DemoForm2.default, {
                            newForm: false,
                            trialButtonOnly: true,
                            modalButtonText: _react2.default.createElement(
                                _react.Fragment,
                                null,
                                _react2.default.createElement(_Picture2.default, { src: '/images/site/whatsapp.png', alt: '\xCDcone do Whatsapp' }),
                                'Falar com especialista'
                            ),
                            className: 'whatsapp-styled-demo'
                        }) : useMinimalStyle ? _react2.default.createElement(_DemoForm2.default, {
                            minimalStyle: true,
                            trialAndDemo: trialAndDemo || 'comece grátis',
                            showForm: true,
                            submitButtonText: submitButtonText || 'Solicitar demonstração',
                            modalButtonText: modalButtonText || 'Peça uma demonstração',
                            showTrialLink: false,
                            className: 'final-cta-form'
                        }) : useB2BForm ? _react2.default.createElement(
                            _react.Fragment,
                            null,
                            _react2.default.createElement(_DemoFormB2B2.default, {
                                trialAndDemo: trialAndDemo || 'comece grátis',
                                showForm: true,
                                submitButtonText: submitButtonText || 'Solicitar demonstração',
                                modalButtonText: modalButtonText || 'Peça uma demonstração',
                                showTrialLink: false
                            }),
                            showTrialInfo && _react2.default.createElement(
                                'p',
                                { className: 'cta-trial-info' },
                                'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a autom\xE1tica'
                            )
                        ) : _react2.default.createElement(_DemoForm2.default, {
                            buttonVariant: buttonVariant || 'inverted-white',
                            textAlign: 'center'
                        })
                    )
                )
            )
        )
    );
};

exports.default = FinalCTACard;

/***/ }),

/***/ 570:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

__webpack_require__(574);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SingleTestimonialCard = function SingleTestimonialCard(_ref) {
  var text = _ref.text,
      stars = _ref.stars,
      personName = _ref.personName,
      companyName = _ref.companyName,
      personImage = _ref.personImage,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$testimonialEleme = _ref.testimonialElementType,
      testimonialElementType = _ref$testimonialEleme === undefined ? 'h4' : _ref$testimonialEleme;

  return _react2.default.createElement(
    'div',
    { className: 'single-testimonial-card ' + className },
    _react2.default.createElement(
      'div',
      { className: 'testimonial-content' },
      stars && _react2.default.createElement(
        'div',
        { className: 'testimonial-stars', 'aria-hidden': 'true' },
        stars
      ),
      _react2.default.createElement(testimonialElementType, { className: "testimonial-text" }, '"' + text + '"'),
      _react2.default.createElement(
        'div',
        { className: 'testimonial-author' },
        personImage && _react2.default.createElement(_Picture2.default, {
          src: personImage,
          alt: personName,
          className: 'author-image'
        }),
        _react2.default.createElement(
          'div',
          { className: 'author-info' },
          _react2.default.createElement(
            'div',
            { className: 'author-name' },
            personName
          ),
          companyName && _react2.default.createElement(
            'div',
            { className: 'author-company' },
            companyName
          )
        )
      )
    )
  );
};

exports.default = SingleTestimonialCard;

/***/ }),

/***/ 574:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 575:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

__webpack_require__(582);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LazyYouTube = function LazyYouTube(_ref) {
    var videoId = _ref.videoId,
        coverImage = _ref.coverImage,
        title = _ref.title,
        _ref$width = _ref.width,
        width = _ref$width === undefined ? 300 : _ref$width,
        _ref$height = _ref.height,
        height = _ref$height === undefined ? 550 : _ref$height,
        _ref$playerParams = _ref.playerParams,
        playerParams = _ref$playerParams === undefined ? '' : _ref$playerParams,
        _ref$useNoCookie = _ref.useNoCookie,
        useNoCookie = _ref$useNoCookie === undefined ? false : _ref$useNoCookie;

    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        isLoaded = _useState2[0],
        setIsLoaded = _useState2[1];

    var embedBaseUrl = useNoCookie ? 'https://www.youtube.com/embed/' : 'https://www.youtube.com/embed/';
    var embedParams = ['autoplay=1', playerParams].filter(Boolean).join('&');

    var handleClick = function handleClick() {
        setIsLoaded(true);
        if (typeof window !== 'undefined' && window.dataLayer) {
            window.dataLayer.push({
                event: 'video_play',
                videoId: videoId,
                videoTitle: title || 'YouTube video player',
                videoUrl: '' + embedBaseUrl + videoId
            });
        }
    };

    if (isLoaded) {
        return _react2.default.createElement(
            'div',
            { className: 'lazy-youtube-frame', style: { aspectRatio: width + ' / ' + height } },
            _react2.default.createElement('iframe', {
                className: 'lazy-youtube-embed',
                width: width,
                height: height,
                src: '' + embedBaseUrl + videoId + '?' + embedParams,
                title: title || "YouTube video player",
                frameBorder: '0',
                allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
                referrerPolicy: 'strict-origin-when-cross-origin',
                allowFullScreen: true
            })
        );
    }

    return _react2.default.createElement(
        'div',
        { className: 'lazy-youtube-frame', style: { aspectRatio: width + ' / ' + height } },
        _react2.default.createElement(
            'button',
            { className: 'lazy-youtube', onClick: handleClick, 'aria-label': 'Play video: ' + title },
            _react2.default.createElement(_Picture2.default, {
                src: coverImage,
                alt: title || "Video thumbnail",
                className: 'lazy-youtube-cover'
            })
        )
    );
};

exports.default = LazyYouTube;

/***/ }),

/***/ 582:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _LazyYouTube = __webpack_require__(580);

var _LazyYouTube2 = _interopRequireDefault(_LazyYouTube);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

__webpack_require__(595);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var aiTestimonialsData = [{
    testimonial: _react2.default.createElement(
        _react.Fragment,
        null,
        '"Acabei seguindo o mesmo processo que usava ao adicionar por planilha, porque \xE9 mais c\xF4modo. O mais incr\xEDvel \xE9 que a ferramenta permite alterar a quantidade de uma refer\xEAncia, caso esteja errada, j\xE1 no momento da importa\xE7\xE3o, sem precisar ficar ajustando a planilha v\xE1rias vezes. ',
        _react2.default.createElement(
            'b',
            null,
            'Simplesmente perfeito!'
        ),
        '"'
    ),
    author: "Kaio Azevedo",
    company: "WKF Representações",
    stars: 5
}, {
    testimonial: _react2.default.createElement(
        _react.Fragment,
        null,
        '"Bem legal! Otimiza bastante o tempo para as empresas que recebem muitos pedidos pelo WhatsApp e perdem tempo criando tudo manualmente. Com a IA, \xE9 s\xF3 copiar e colar a mensagem e, se for necess\xE1rio, ajustar algum item. ',
        _react2.default.createElement(
            'b',
            null,
            '\xC9 r\xE1pido, simples e muito eficiente.'
        ),
        '"'
    ),
    author: "Eduardo Woiciechoski",
    company: "WB Distribuidora",
    stars: 5
}, {
    testimonial: _react2.default.createElement(
        _react.Fragment,
        null,
        '"',
        _react2.default.createElement(
            'b',
            null,
            'Tem sido bem \xFAtil mesmo!'
        ),
        ' O que mais notei de diferen\xE7a foi o tempo que tenho economizado. Antes eu ficava muito tempo fazendo pedidos que recebo por e-mail ou whatsapp manualmente, tendo que colocar n\xFAmero exato de cada produto, e agora com a IA isso ficou muito mais r\xE1pido.'
    ),
    author: "Bruno Barbosa",
    company: "Barbosa & Colombi",
    stars: 5
}];

var homeTestimonialsData = [{
    testimonial: _react2.default.createElement(
        _react.Fragment,
        null,
        'Faz\xEDamos v\xE1rias reuni\xF5es presenciais com grandes contas e precis\xE1vamos registrar rapidamente pedidos com muitos itens, em grandes quantidades. Lev\xE1vamos bastante tempo para concluir tudo. Hoje, com o Pedidos com IA, a emiss\xE3o ficou muito mais \xE1gil. O Mercos tem uma tecnologia que realmente facilita nosso dia a dia.'
    ),
    author: "Jéssica Araujo",
    company: "Océane",
    stars: 5,
    img: "jessica-araujo",
    imgAlt: "Jéssica Araujo, Océane"
}, {
    testimonial: _react2.default.createElement(
        _react.Fragment,
        null,
        'A facilidade do cliente fazer os pedidos conosco foi o principal ponto. Ficamos extremamente felizes em saber que nossos clientes, gostam, se adaptam bem e n\xE3o t\xEAm dificuldades. \xC9 tudo muito simples, interativo e f\xE1cil de usar. O sistema \xE9 muito completo e facilita muito a nossa vida!'
    ),
    author: "Alessandro Gonçalves",
    company: "Diretor Comercial da Mels Brushes",
    stars: 5,
    img: "alessandro-goncalves",
    imgAlt: "Alessandro Gonçalves, Diretor Comercial da Mels Brushes"
}, {
    testimonial: _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
            'b',
            null,
            'Aumento de 20% do faturamento com o e-commerce B2B'
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        'Evolu\xEDmos na qualidade dos pedidos, desde a maneira que a gente entrega o pedido pras empresas como na maneira com que a gente gera os pedidos.'
    ),
    author: "Henrique Zompeiro",
    company: "Gerente Financeiro na CorsaBIke",
    stars: 5,
    img: "henrique-zompeiro",
    imgAlt: "Henrique Zompeiro, Gerente Financeiro na CorsaBike"
}];

var TestimonialVideoCards = function (_Component) {
    _inherits(TestimonialVideoCards, _Component);

    function TestimonialVideoCards(props) {
        _classCallCheck(this, TestimonialVideoCards);

        return _possibleConstructorReturn(this, (TestimonialVideoCards.__proto__ || Object.getPrototypeOf(TestimonialVideoCards)).call(this, props));
    }

    _createClass(TestimonialVideoCards, [{
        key: 'getTestimonials',
        value: function getTestimonials() {
            var testimonialList = {
                joseDavidCopelman: {
                    img: "jose-david-copelman",
                    imgAlt: "José David Copelman, Gestor Nacional de Vendas na CROWN",
                    title: "Crescimento de 12% em vendas em 2023",
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'Antes do Mercos, eram 3 pessoas exclusivas para lan\xE7ar pedidos. Hoje com os dois sistemas integrados, ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'ganhamos controle e efici\xEAncia em nossa opera\xE7\xE3o'
                        ),
                        '.'
                    ),
                    author: "José David Copelman",
                    company: "Gestor Nacional de Vendas na CROWN"
                },
                leandroCampos: {
                    img: "leandro-campos",
                    imgAlt: "Leandro Campos, Gestor Comercial e Marketing na Tagima",
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'Nossos clientes t\xEAm uma primeira experi\xEAncia positiva, pois o E-commerce B2B \xE9 t\xE3o intuitivo e f\xE1cil de usar quanto o For\xE7a de vendas. O principal ganho foi a velocidade na tratativa de pedidos. Agora, conseguimos processar mais notas por dia e, at\xE9 mesmo, integrar estoque.'
                    ),
                    author: "Leandro Campos",
                    company: "Gestor Comercial e Marketing na Tagima"
                },
                henriqueZompeiroOld: {
                    img: "henrique-zompeiro",
                    imgAlt: "Henrique Zompeiro, Gerente Financeiro na CorsaBike",
                    title: "Aumento de 20% do faturamento com o e-commerce B2B",
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'Evolu\xEDmos na qualidade dos pedidos, desde a maneira que a gente entrega o pedido pras empresas como na maneira com que a gente gera os pedidos.'
                    ),
                    author: "Henrique Zompeiro",
                    company: "Gerente Financeiro na CorsaBike",
                    className: "desktop-only"
                },
                allanGomes: {
                    img: "allan-gomes",
                    imgAlt: "Allan Gomes, Sócio proprietário da La Ganexa",
                    title: "O Mercos economizou 2 dias de trabalho mensal que tínhamos antes",
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'Al\xE9m de trazer economia de tempo e efici\xEAncia para o nosso processo, tamb\xE9m trouxe mais dinheiro para a La Ganexa.'
                    ),
                    author: "Allan Gomes",
                    company: "Sócio proprietário da La Ganexa"
                },
                felipeAlmeida: {
                    img: "felipe-almeida",
                    imgAlt: "Felipe Almeida, HPrime",
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'Hoje, os vendedores est\xE3o muito mais focados na rela\xE7\xE3o com o cliente e em serem especialistas que ajudam na venda e no p\xF3s-venda do que em resolver as min\xFAcias burocr\xE1ticas de uma tabela, por exemplo'
                    ),
                    author: "Felipe Almeida",
                    company: "HPrime"
                },
                alexandreSantos: {
                    img: "alexandre-santos-delicia-lanches",
                    imgAlt: "Alexandre Santos, Delícia Lanches",
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'Imagine a nossa felicidade em ganhar produtividade, se adaptar ao mercado e \xE0s tend\xEAncias. N\xE3o tem jeito, quem n\xE3o faz isso perde grandes oportunidades.'
                    ),
                    author: "Alexandre Santos",
                    company: "Delícia Lanches",
                    className: "desktop-only"
                },
                francielMartins: {
                    img: "franciel-martins",
                    imgAlt: "Franciel Martins",
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'O Mercos transformou completamente nossa opera\xE7\xE3o de vendas. A facilidade de uso e a integra\xE7\xE3o com nossos sistemas existentes nos permitiu aumentar significativamente nossa produtividade.'
                    ),
                    author: "Franciel Martins",
                    company: "Empresa Demo"
                },
                francielMartins2: {
                    img: "franciel",
                    imgAlt: "Franciel Martins, ZT Representações",
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'O Mercos pra gente foi um divisor de \xE1guas na quest\xE3o da opera\xE7\xE3o. Evolu\xEDmos na qualidade dos pedidos, desde a maneira que a gente entrega o pedido pras empresas como na maneira com que a gente gera e monta os pedidos.'
                    ),
                    author: "Franciel Martins",
                    company: "ZT Representações"
                },
                joaoDePauloOliveira: {
                    img: "joao-paulo-oliveira",
                    imgAlt: "João de Paulo Oliveira, Gao Cosméticos",
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'Eu pesquisei solu\xE7\xF5es de mercado e decidi contratar Mercos porque a ferramenta al\xE9m de ser f\xE1cil de usar, me oferece tr\xEAs recursos que meu neg\xF3cio precisa: e-commerce B2B, for\xE7a de vendas e indicadores gerenciais'
                    ),
                    author: "João de Paulo Oliveira",
                    company: "Gao Cosméticos"
                }
            };

            // Return testimonials based on props
            if (this.props.tpPage) {
                return [testimonialList.francielMartins2, testimonialList.felipeAlmeida, testimonialList.joaoDePauloOliveira];
            }

            return [testimonialList.leandroCampos, testimonialList.felipeAlmeida, testimonialList.alexandreSantos];
        }
    }, {
        key: 'defaultTestimonials',
        value: function defaultTestimonials() {
            var _props = this.props,
                isAI = _props.isAI,
                isHome = _props.isHome,
                sectionTitle = _props.title,
                descriptionH4 = _props.descriptionH4,
                isAIPage = _props.isAIPage,
                noVideo = _props.noVideo,
                tpPage = _props.tpPage,
                customTestimonialsProp = _props.customTestimonials,
                isDistributor = _props.isDistributor;
            // Prefer explicit customTestimonials passed via props (page-specific overrides)

            var baseTestimonials = isAI ? aiTestimonialsData : isHome ? homeTestimonialsData : [];
            var customTestimonials = Array.isArray(customTestimonialsProp) && customTestimonialsProp.length > 0 ? customTestimonialsProp : tpPage ? this.getTestimonials() : [];
            var testimonialsToRender = customTestimonials.length > 0 ? customTestimonials : baseTestimonials;

            var TitleComponent = isAIPage ? 'h3' : 'h3';
            var containerClass = isDistributor ? 'static-testimonials static-testimonials-distributor' : 'static-testimonials static-testimonials-b2b';

            return _react2.default.createElement(
                'div',
                { className: containerClass },
                _react2.default.createElement(
                    'div',
                    { className: 'testimonials-title ' + (sectionTitle ? 'testimonials-title-picture-second-title' : '') },
                    _react2.default.createElement(
                        'div',
                        { className: 'testimonials-title-slider-btns' },
                        sectionTitle ? _react2.default.createElement(
                            TitleComponent,
                            { className: 'title' },
                            sectionTitle
                        ) : ''
                    )
                ),
                !noVideo && _react2.default.createElement(
                    'div',
                    { className: 'testimonials-videos' },
                    _react2.default.createElement(
                        'div',
                        { className: 'container' },
                        isAIPage ? _react2.default.createElement(
                            _react.Fragment,
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'video' },
                                _react2.default.createElement('iframe', { loading: 'lazy', width: '300', height: '550', src: 'https://www.youtube.com/embed/hg8RE2ebBKw', title: 'YouTube video player', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', referrerPolicy: 'strict-origin-when-cross-origin', allowFullScreen: true })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'video desktop' },
                                _react2.default.createElement('iframe', { loading: 'lazy', width: '300', height: '550', src: 'https://www.youtube.com/embed/GbkxUaWZYJw', title: 'YouTube video player', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', referrerPolicy: 'strict-origin-when-cross-origin', allowFullScreen: true })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'video' },
                                _react2.default.createElement('iframe', { loading: 'lazy', width: '300', height: '550', src: 'https://www.youtube.com/embed/oBLU1_LOL3A', title: 'YouTube video player', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', referrerPolicy: 'strict-origin-when-cross-origin', allowFullScreen: true })
                            )
                        ) : isAI ? _react2.default.createElement(
                            _react.Fragment,
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'video' },
                                _react2.default.createElement('iframe', { loading: 'lazy', width: '300', height: '550', src: 'https://www.youtube.com/embed/hg8RE2ebBKw', title: 'YouTube video player', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', referrerPolicy: 'strict-origin-when-cross-origin', allowFullScreen: true })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'video desktop' },
                                _react2.default.createElement('iframe', { loading: 'lazy', width: '300', height: '550', src: 'https://www.youtube.com/embed/GbkxUaWZYJw', title: 'YouTube video player', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', referrerPolicy: 'strict-origin-when-cross-origin', allowFullScreen: true })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'video' },
                                _react2.default.createElement('iframe', { loading: 'lazy', width: '300', height: '550', src: 'https://www.youtube.com/embed/oBLU1_LOL3A', title: 'YouTube video player', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', referrerPolicy: 'strict-origin-when-cross-origin', allowFullScreen: true })
                            )
                        ) : isHome ? _react2.default.createElement(
                            _react.Fragment,
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'video' },
                                _react2.default.createElement(_LazyYouTube2.default, { videoId: '6qEule4v-b8', coverImage: '/images/site/depoimentos/alessandro-vertical-video.png', title: 'Depoimento Alessandro' })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'video desktop' },
                                _react2.default.createElement(_LazyYouTube2.default, { videoId: 'kF5GQkz6J6w', coverImage: '/images/site/depoimentos/bruno-vertical-video.png', title: 'Depoimento Bruno' })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'video' },
                                _react2.default.createElement(_LazyYouTube2.default, { videoId: '9Z2o648HcBw', coverImage: '/images/site/depoimentos/rafael-vertical-video.png', title: 'Depoimento Rafael' })
                            )
                        ) : _react2.default.createElement(
                            _react.Fragment,
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'video' },
                                _react2.default.createElement('iframe', { loading: 'lazy', width: '300', height: '550', src: 'https://www.youtube.com/embed/FHnSkFs8Xmg?si=Nuatrl8SzhFXIDbK&controls=0', title: 'YouTube video player', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', referrerPolicy: 'strict-origin-when-cross-origin', allowFullScreen: true })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'video desktop-only' },
                                _react2.default.createElement('iframe', { loading: 'lazy', width: '300', height: '550', src: 'https://www.youtube.com/embed/eFgUXUQdq2M?si=TaKxCao1DPTKKGXa&controls=0', title: 'YouTube video player', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', referrerPolicy: 'strict-origin-when-cross-origin', allowFullScreen: true })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'video' },
                                _react2.default.createElement('iframe', { loading: 'lazy', width: '300', height: '550', src: 'https://www.youtube.com/embed/6qEule4v-b8?si=6TnmqyVB8SGDlz-t&controls=0', title: 'YouTube video player', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', referrerPolicy: 'strict-origin-when-cross-origin', allowFullScreen: true })
                            )
                        )
                    )
                ),
                testimonialsToRender && testimonialsToRender.length > 0 ? _react2.default.createElement(
                    'div',
                    { className: 'testimonial-cards-container' },
                    testimonialsToRender.map(function (testimonial, index) {
                        return _react2.default.createElement(
                            'div',
                            { key: index, className: 'testimonial-card ' + (testimonial.className || '') },
                            _react2.default.createElement(
                                'div',
                                { className: 'testimonial-card-head' },
                                testimonial.categoryIcon ? _react2.default.createElement(
                                    'div',
                                    { className: 'testimonial-category-badge' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'category-icon' },
                                        _react2.default.createElement(_Picture2.default, { src: testimonial.categoryIcon, alt: '' })
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'testimonial-category-text' },
                                        testimonial.categoryText
                                    )
                                ) : _react2.default.createElement(
                                    'span',
                                    { className: 'testimonial-card-stars' },
                                    '★'.repeat(testimonial.stars || 5)
                                )
                            ),
                            testimonial.title && _react2.default.createElement(
                                'p',
                                { className: 'testimonial-card-title' },
                                testimonial.title
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'testimonial-card-paragraph' },
                                testimonial.testimonial
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'testimonial-card-header' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'testimonial-card-author-company' },
                                    testimonial.img && _react2.default.createElement(_Picture2.default, { className: 'profile-image', alt: testimonial.imgAlt, width: '50', src: '/images/site/depoimentos/' + testimonial.img + '.png' }),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'testimonial-author-wrapper' },
                                        _react2.default.createElement(
                                            'p',
                                            { className: 'testimonial-card-author' },
                                            testimonial.author
                                        ),
                                        _react2.default.createElement(
                                            'p',
                                            { className: 'testimonial-card-company' },
                                            testimonial.company
                                        )
                                    )
                                )
                            )
                        );
                    })
                ) : null
            );
        }
    }, {
        key: 'repsTestimonials',
        value: function repsTestimonials() {
            return _react2.default.createElement(
                'div',
                { className: 'static-testimonials' },
                'Reps Testimonials (Not Implemented with AI prop yet)'
            );
        }
    }, {
        key: 'blacknovTestimonials',
        value: function blacknovTestimonials() {
            return _react2.default.createElement(
                'div',
                { className: 'static-testimonials' },
                'Black November Testimonials (Not Implemented with AI prop yet)'
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                this.props.reps ? this.repsTestimonials() : this.props.blackNovember ? this.blacknovTestimonials() : this.defaultTestimonials()
            );
        }
    }]);

    return TestimonialVideoCards;
}(_react.Component);

exports.default = TestimonialVideoCards;

/***/ }),

/***/ 595:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _SingleTestimonialCard = __webpack_require__(573);

var _SingleTestimonialCard2 = _interopRequireDefault(_SingleTestimonialCard);

__webpack_require__(575);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TwoColsV2 = function TwoColsV2(_ref) {
  var overTitle = _ref.overTitle,
      title = _ref.title,
      description = _ref.description,
      imageSrc = _ref.imageSrc,
      imageAlt = _ref.imageAlt,
      mobileSrc = _ref.mobileSrc,
      _ref$isReverse = _ref.isReverse,
      isReverse = _ref$isReverse === undefined ? false : _ref$isReverse,
      _ref$isImageFullWidth = _ref.isImageFullWidth,
      isImageFullWidth = _ref$isImageFullWidth === undefined ? false : _ref$isImageFullWidth,
      testimonial = _ref.testimonial,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      children = _ref.children,
      radialBg = _ref.radialBg,
      _ref$testimonialEleme = _ref.testimonialElementType,
      testimonialElementType = _ref$testimonialEleme === undefined ? 'h4' : _ref$testimonialEleme,
      _ref$descriptionEleme = _ref.descriptionElementType,
      descriptionElementType = _ref$descriptionEleme === undefined ? 'div' : _ref$descriptionEleme,
      _ref$separateHeadings = _ref.separateHeadings,
      separateHeadings = _ref$separateHeadings === undefined ? false : _ref$separateHeadings;

  var sectionClass = 'two-cols-v2 ' + (isReverse ? 'reverse' : '') + ' ' + (isImageFullWidth ? 'full-width-image' : '') + ' ' + className;
  var DescriptionElement = descriptionElementType;

  return _react2.default.createElement(
    'section',
    { className: sectionClass },
    radialBg && _react2.default.createElement('div', { className: 'radial-bg ' + radialBg + ' small' }),
    _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(
        'div',
        { className: 'content-column' },
        separateHeadings ? _react2.default.createElement(
          _react.Fragment,
          null,
          overTitle && _react2.default.createElement(
            'p',
            { className: 'over-title' },
            overTitle
          ),
          title && _react2.default.createElement(
            'h3',
            { className: 'title' },
            title
          )
        ) : _react2.default.createElement(
          'h3',
          null,
          overTitle && _react2.default.createElement(
            'div',
            { className: 'over-title' },
            overTitle
          ),
          title && _react2.default.createElement(
            'div',
            { className: 'title' },
            title
          )
        ),
        description && _react2.default.createElement(
          DescriptionElement,
          { className: 'description' },
          description
        ),
        _react2.default.createElement(
          'div',
          { className: 'mobile-only' },
          _react2.default.createElement(_Picture2.default, {
            className: 'section-image',
            src: imageSrc,
            alt: imageAlt,
            mobileSrc: mobileSrc
          })
        ),
        children,
        testimonial && _react2.default.createElement(_SingleTestimonialCard2.default, _extends({}, testimonial, { testimonialElementType: testimonialElementType }))
      ),
      _react2.default.createElement(
        'div',
        { className: 'image-column desktop-only' },
        _react2.default.createElement(_Picture2.default, {
          className: 'section-image',
          src: imageSrc,
          alt: imageAlt,
          mobileSrc: mobileSrc
        })
      )
    )
  );
};

exports.default = TwoColsV2;

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _Paragraph = __webpack_require__(543);

var _Paragraph2 = _interopRequireDefault(_Paragraph);

__webpack_require__(629);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SimpleAccordionItem = function SimpleAccordionItem(_ref) {
    var children = _ref.children,
        classes = _ref.classes,
        expand = _ref.expand,
        icon = _ref.icon,
        onClick = _ref.onClick,
        opened = _ref.opened,
        title = _ref.title,
        headerTag = _ref.headerTag;

    var HeaderTag = headerTag || 'span';

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('simple-accordion-item', icon && 'hasIcon', opened && 'opened') },
        _react2.default.createElement(
            'div',
            { className: 'simple-accordion-item-title-block', onClick: onClick },
            icon && _react2.default.createElement(
                'div',
                { className: 'icon-container' },
                _react2.default.createElement(_Picture2.default, { src: icon, alt: title, width: 45, height: 45 })
            ),
            _react2.default.createElement(
                'div',
                { className: 'border-accordion' },
                _react2.default.createElement(
                    HeaderTag,
                    { className: (0, _classnames2.default)('always-left', opened && classes && classes.titleOpened, classes && classes.title) },
                    title
                ),
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('accordion-see-more', expand) },
                    !opened && expand === 'text' ? _react2.default.createElement(
                        _Paragraph2.default,
                        { gray: true },
                        'Ver mais'
                    ) : _react2.default.createElement('div', { className: 'arrow-container' })
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('accordion-content', opened ? 'accordion-item-opened' : '') },
            children
        )
    );
};

SimpleAccordionItem.defaultProps = {
    classes: {
        titleOpened: 'accordion-title-selected'
    }
};

SimpleAccordionItem.propTypes = {
    children: _propTypes2.default.node,
    classes: _propTypes2.default.object,
    expand: _propTypes2.default.string,
    headerTag: _propTypes2.default.string,
    icon: _propTypes2.default.string,
    opened: _propTypes2.default.bool,
    title: _propTypes2.default.string
};

exports.default = SimpleAccordionItem;

/***/ }),

/***/ 614:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _Utm = __webpack_require__(532);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

__webpack_require__(620);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CallToActionSection = function CallToActionSection() {
    return _react2.default.createElement(
        'section',
        { className: 'call-to-action-section' },
        _react2.default.createElement('div', { className: 'radial-bg purple small' }),
        _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
                'div',
                { className: 'content-wrapper' },
                _react2.default.createElement(
                    'div',
                    { className: 'left-content' },
                    _react2.default.createElement(
                        'p',
                        { className: 'title' },
                        'Conhe\xE7a nossos planos e teste gr\xE1tis'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'description' },
                        'Mais de 9.000 empresas confiam no Mercos para impulsionar a automa\xE7\xE3o da for\xE7a de vendas'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'buttons-wrapper' },
                        _react2.default.createElement(
                            'button',
                            {
                                className: 'new-form-btn new-form-btn-solid-green',
                                onClick: function onClick() {
                                    return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                                },
                                href: '#',
                                title: 'Fa\xE7a um teste gr\xE1tis'
                            },
                            'Fa\xE7a um teste gr\xE1tis'
                        ),
                        _react2.default.createElement(
                            'a',
                            { className: 'new-form-btn new-form-btn-bordered-green',
                                href: '/planos-e-precos/industrias-e-distribuidoras/'
                            },
                            'Ver planos e pre\xE7os'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'cta-bottom-text' },
                        _react2.default.createElement(
                            'span',
                            { className: 'desktop-text' },
                            'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a ao terminar o per\xEDodo gr\xE1tis | Explore todos os recursos'
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'mobile-text' },
                            'Teste gr\xE1tis por 7 dias',
                            _react2.default.createElement('br', null),
                            'Sem cobran\xE7a ao terminar o per\xEDodo gr\xE1tis',
                            _react2.default.createElement('br', null),
                            'Explore todos os recursos'
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'right-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'testimonial' },
                        _react2.default.createElement(
                            'div',
                            { className: 'author-avatar' },
                            _react2.default.createElement(_Picture2.default, {
                                src: '/images/site/depoimentos/rafael-vila-hr.png',
                                alt: 'Alessandro Gon\xE7alves',
                                className: 'avatar-image'
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'testimonial-content' },
                            _react2.default.createElement(
                                'p',
                                { className: 'testimonial-text' },
                                '\u201CEm pouco tempo, o Mercos j\xE1 fez uma grande diferen\xE7a: conseguimos construir hist\xF3ricos de compras, entender o que os clientes levam ou n\xE3o e at\xE9 recuperar uma linha de produtos que n\xE3o estava saindo. Batemos nossas metas e seguimos crescendo.\u201D'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'testimonial-author' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'author-info' },
                                    _react2.default.createElement(
                                        'p',
                                        { className: 'author-name' },
                                        'Rafael Vila'
                                    ),
                                    _react2.default.createElement(
                                        'p',
                                        { className: 'author-position' },
                                        'Gerente comercial da Trato Vegano'
                                    )
                                )
                            )
                        )
                    )
                )
            )
        )
    );
};

exports.default = CallToActionSection;

/***/ }),

/***/ 620:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 621:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _constants = __webpack_require__(555);

__webpack_require__(622);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeroRatings = function HeroRatings(_ref) {
  var _ref$hideGoogleMyBusi = _ref.hideGoogleMyBusiness,
      hideGoogleMyBusiness = _ref$hideGoogleMyBusi === undefined ? false : _ref$hideGoogleMyBusi,
      _ref$showTitle = _ref.showTitle,
      showTitle = _ref$showTitle === undefined ? false : _ref$showTitle,
      _ref$noMargin = _ref.noMargin,
      noMargin = _ref$noMargin === undefined ? false : _ref$noMargin,
      _ref$noWrapper = _ref.noWrapper,
      noWrapper = _ref$noWrapper === undefined ? false : _ref$noWrapper;

  var content = _react2.default.createElement(
    _react2.default.Fragment,
    null,
    showTitle && _react2.default.createElement(
      'p',
      { className: 'ia-hero-ratings-title' },
      'O Aplicativo mais bem avaliado do mercado:'
    ),
    _react2.default.createElement(
      'div',
      { className: 'ia-hero-ratings' },
      _react2.default.createElement(
        'div',
        { className: 'ia-rating-card' },
        _react2.default.createElement(
          'div',
          { className: 'ia-rating-info' },
          _react2.default.createElement(
            'div',
            { className: 'ia-rating-score' },
            _react2.default.createElement(
              'span',
              { className: 'ia-rating-value' },
              _constants.SITE_CONSTANTS.GOOGLE_PLAY_RATING
            ),
            _react2.default.createElement(
              'span',
              { className: 'ia-rating-star-char' },
              '\u2605'
            )
          ),
          _react2.default.createElement(
            'span',
            { className: 'ia-rating-reviews-text' },
            _constants.SITE_CONSTANTS.GOOGLE_PLAY_REVIEWS
          )
        ),
        _react2.default.createElement(_Picture2.default, { className: 'ia-rating-platform-logo', alt: 'Google Play Logo', src: '/images/site/recursos/google-play.png' })
      ),
      _react2.default.createElement(
        'div',
        { className: 'ia-rating-card' },
        _react2.default.createElement(
          'div',
          { className: 'ia-rating-info' },
          _react2.default.createElement(
            'div',
            { className: 'ia-rating-score' },
            _react2.default.createElement(
              'span',
              { className: 'ia-rating-value' },
              _constants.SITE_CONSTANTS.APP_STORE_RATING
            ),
            _react2.default.createElement(
              'span',
              { className: 'ia-rating-star-char' },
              '\u2605'
            )
          ),
          _react2.default.createElement(
            'span',
            { className: 'ia-rating-reviews-text' },
            _constants.SITE_CONSTANTS.APP_STORE_REVIEWS
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'ia-rating-platform-appstore' },
          _react2.default.createElement(_Picture2.default, { className: 'ia-rating-platform-logo', alt: 'Apple Logo', src: '/images/site/recursos/app-store.png' })
        )
      ),
      !hideGoogleMyBusiness && _react2.default.createElement(
        'div',
        { className: 'ia-rating-card' },
        _react2.default.createElement(
          'div',
          { className: 'ia-rating-info' },
          _react2.default.createElement(
            'div',
            { className: 'ia-rating-score' },
            _react2.default.createElement(
              'span',
              { className: 'ia-rating-value' },
              _constants.SITE_CONSTANTS.GOOGLE_BUSINESS_RATING
            ),
            _react2.default.createElement(
              'span',
              { className: 'ia-rating-star-char' },
              '\u2605'
            )
          ),
          _react2.default.createElement(
            'span',
            { className: 'ia-rating-reviews-text' },
            _constants.SITE_CONSTANTS.GOOGLE_BUSINESS_REVIEWS
          )
        ),
        _react2.default.createElement(_Picture2.default, { className: 'ia-rating-platform-logo', alt: 'Google Meu Neg\xF3cio Logo', src: '/images/site/recursos/google-meu-negocio.png' })
      )
    )
  );

  if (noWrapper) {
    return content;
  }

  return _react2.default.createElement(
    'div',
    { className: 'ia-hero-ratings-wrapper ' + (noMargin ? 'no-margin' : '') },
    content
  );
};

exports.default = HeroRatings;

/***/ }),

/***/ 622:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

var _SimpleAccordionItem = __webpack_require__(604);

var _SimpleAccordionItem2 = _interopRequireDefault(_SimpleAccordionItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SimpleAccordionContainer = function (_Component) {
    _inherits(SimpleAccordionContainer, _Component);

    function SimpleAccordionContainer(props) {
        _classCallCheck(this, SimpleAccordionContainer);

        var _this = _possibleConstructorReturn(this, (SimpleAccordionContainer.__proto__ || Object.getPrototypeOf(SimpleAccordionContainer)).call(this, props));

        _this.isIndexInList = _this.isIndexInList.bind(_this);
        _this.toggleItem = _this.toggleItem.bind(_this);

        _this.state = {
            openedItems: _this.props.defaultClosed ? [] : [0]
        };
        return _this;
    }

    _createClass(SimpleAccordionContainer, [{
        key: 'toggleItem',
        value: function toggleItem(index, propsFunction) {
            var openedItems = this.state.openedItems;

            if (this.props.collapsable) {
                if (!this.isIndexInList(index)) {
                    this.setState({
                        openedItems: [index]
                    });
                } else {
                    this.setState({
                        openedItems: []
                    });
                }
            } else {
                if (this.isIndexInList(index)) {
                    this.setState({
                        openedItems: openedItems.filter(function (value) {
                            return value != index;
                        })
                    });
                } else {
                    openedItems.push(index);
                    this.setState({
                        openedItems: openedItems
                    });
                }
            }

            propsFunction && propsFunction();
        }
    }, {
        key: 'isIndexInList',
        value: function isIndexInList(index) {
            return this.state.openedItems.includes(index);
        }
    }, {
        key: 'render',
        value: function render() {
            var isIndexInList = this.isIndexInList,
                toggleItem = this.toggleItem,
                expand = this.props.expand,
                openedItems = this.state.openedItems;


            return _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)('accordion-container', expand) },
                _react2.default.Children.map(this.props.children, function (child, index) {
                    return _react2.default.cloneElement(child, { expand: expand, onClick: function onClick() {
                            return toggleItem(index, child.props.onClick);
                        }, opened: isIndexInList(index), key: 'accordion-clone-item-' + index });
                })
            );
        }
    }]);

    return SimpleAccordionContainer;
}(_react.Component);

SimpleAccordionContainer.defaultProps = {
    expand: 'text'
};

SimpleAccordionContainer.propTypes = {
    children: _propTypes2.default.arrayOf(_SimpleAccordionItem2.default),
    expand: _propTypes2.default.string
};

exports.default = SimpleAccordionContainer;

/***/ }),

/***/ 629:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _TestimonialVideoCards = __webpack_require__(594);

var _TestimonialVideoCards2 = _interopRequireDefault(_TestimonialVideoCards);

var _HeroRatings = __webpack_require__(621);

var _HeroRatings2 = _interopRequireDefault(_HeroRatings);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

__webpack_require__(614);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TestimonialsVideoCardsV5 = function TestimonialsVideoCardsV5(_ref) {
  var _ref$industryVersion = _ref.industryVersion,
      industryVersion = _ref$industryVersion === undefined ? false : _ref$industryVersion,
      _ref$distributorVersi = _ref.distributorVersion,
      distributorVersion = _ref$distributorVersi === undefined ? false : _ref$distributorVersi,
      _ref$showClientLogos = _ref.showClientLogos,
      showClientLogos = _ref$showClientLogos === undefined ? true : _ref$showClientLogos,
      passedCustomTestimonials = _ref.customTestimonials;
  return _react2.default.createElement(
    'section',
    { className: 'ia-testimonial-section container' },
    _react2.default.createElement(_TestimonialVideoCards2.default, {
      isHome: !industryVersion && !distributorVersion,
      isAI: industryVersion || distributorVersion,
      noVideo: industryVersion || distributorVersion,
      isDistributor: distributorVersion,
      customTestimonials: passedCustomTestimonials || (industryVersion ? [{
        testimonial: _react2.default.createElement(
          _react.Fragment,
          null,
          '"Com o Mercos, os vendedores geram or\xE7amentos e emitem pedidos sem complica\xE7\xE3o e sem controles manuais. Isso reduz erros, economiza tempo e acaba com a necessidade de levar trabalho para casa, j\xE1 que o sistema resolve tudo na hora"'
        ),
        author: "Mauricio Perin",
        company: "Flach Equipamentos Inteligentes",
        stars: 5,
        img: "mauricio-perin",
        imgAlt: "Mauricio Perin, Flach Equipamentos Inteligentes"
      }, {
        testimonial: _react2.default.createElement(
          _react.Fragment,
          null,
          '"Hoje, com o Mercos, nosso time comercial fecha vendas e calcula or\xE7amentos em tempo real, com agilidade, sem erros e em um s\xF3 lugar. J\xE1 o time interno foca demandas mais estrat\xE9gicas, j\xE1 que n\xE3o h\xE1 mais retrabalho na digita\xE7\xE3o de pedidos"'
        ),
        author: "Natália Costa",
        company: "Vouga Decor",
        stars: 5,
        img: "natalia-costa",
        imgAlt: "Natália Costa, Vouga Decor"
      }, {
        testimonial: _react2.default.createElement(
          _react.Fragment,
          null,
          '"Com o e-commerce B2B, nossos clientes ampliam o mix de compras e nos veem como uma empresa mais atualizada e acess\xEDvel. Utilizamos a plataforma de forma estrat\xE9gica e aumentamos vendas, fideliza\xE7\xE3o e a liberdade dos clientes de comprar a qualquer hora"'
        ),
        author: "Eduarda Berwanger",
        company: "Berwanger Abrasivos",
        stars: 5,
        // img: "eduarda-berwanger",
        imgAlt: "Eduarda Berwanger, Berwanger Abrasivos"
      }] : undefined),
      title: !industryVersion && !distributorVersion ? _react2.default.createElement(
        'span',
        { className: 'testimonials-v5-title' },
        '+ 9 mil clientes melhoram a sua opera\xE7\xE3o comercial com a Mercos'
      ) : null
    }),
    industryVersion || distributorVersion ? _react2.default.createElement(_HeroRatings2.default, null) : showClientLogos ? _react2.default.createElement(
      'div',
      { className: 'client-logos-section' },
      _react2.default.createElement(
        'div',
        { className: 'client-logos-grid' },
        _react2.default.createElement(
          'div',
          { className: 'client-logo-item' },
          _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/logo-companies/oakberry.png', alt: 'Oakberry logo', className: 'client-logo-image' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'client-logo-item' },
          _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/logo-companies/tagima.png', alt: 'Tagima logo', className: 'client-logo-image' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'client-logo-item' },
          _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/logo-companies/mili.png', alt: 'Mili logo', className: 'client-logo-image' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'client-logo-item' },
          _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/logo-companies/mtx.png', alt: 'MTX logo', className: 'client-logo-image' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'client-logo-item' },
          _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/logo-companies/anasol.png', alt: 'Anasol logo', className: 'client-logo-image' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'client-logo-item' },
          _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/logo-companies/berwanger.png', alt: 'Berwanger logo', className: 'client-logo-image' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'client-logo-item' },
          _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/logo-companies/maped.png', alt: 'Maped logo', className: 'client-logo-image' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'client-logo-item' },
          _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/logo-companies/keune.png', alt: 'Keune logo', className: 'client-logo-image' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'client-logo-item' },
          _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/logo-companies/gelopar.png', alt: 'Gelopar logo', className: 'client-logo-image' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'client-logo-item' },
          _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/logo-companies/cicero.png', alt: 'Cicero logo', className: 'client-logo-image' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'client-logo-item' },
          _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/logo-companies/ftw.png', alt: 'FTW logo', className: 'client-logo-image' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'client-logo-item' },
          _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/logo-companies/buffalo.png', alt: 'Buffalo logo', className: 'client-logo-image' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'client-logo-item' },
          _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/logo-companies/herbia.png', alt: 'Herbia logo', className: 'client-logo-image' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'client-logo-item' },
          _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/logo-companies/beyoung.png', alt: 'Beyoung logo', className: 'client-logo-image' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'client-logo-item' },
          _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/logo-companies/alva.png', alt: 'Alva logo', className: 'client-logo-image' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'client-logo-item' },
          _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/logo-companies/labotrat.png', alt: 'Labotrat logo', className: 'client-logo-image' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'client-logo-item' },
          _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/logo-companies/baggio.png', alt: 'Baggio logo', className: 'client-logo-image' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'client-logo-item' },
          _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/logo-companies/la-ganexa.png', alt: 'La Ganexa logo', className: 'client-logo-image' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'client-logo-item' },
          _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/logo-companies/dobro.png', alt: 'Dobro logo', className: 'client-logo-image' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'client-logo-item' },
          _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/logo-companies/hprime.png', alt: 'HPrime logo', className: 'client-logo-image' })
        )
      )
    ) : null
  );
};

exports.default = TestimonialsVideoCardsV5;

/***/ }),

/***/ 632:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Local drag-to-scroll with click guard; safe to use without affecting other pages
var SmoothDragScroll = function (_React$Component) {
  _inherits(SmoothDragScroll, _React$Component);

  function SmoothDragScroll(props) {
    _classCallCheck(this, SmoothDragScroll);

    var _this = _possibleConstructorReturn(this, (SmoothDragScroll.__proto__ || Object.getPrototypeOf(SmoothDragScroll)).call(this, props));

    _this.onPointerDown = function (e) {
      var el = _this.slider.current;
      if (!el) return;
      try {
        el.setPointerCapture(e.pointerId);
      } catch (_) {}
      _this.isDown = true;
      _this.dragMoved = false;
      _this.startX = e.clientX;
      _this.startScrollLeft = el.scrollLeft;
      // Disable snapping during drag to avoid jumpiness
      _this.prevSnap = el.style.scrollSnapType || '';
      if (!_this.prevSnap && typeof window !== 'undefined') {
        var cs = window.getComputedStyle(el);
        _this.prevSnap = cs.scrollSnapType || '';
      }
      el.style.scrollSnapType = 'none';
      el.style.cursor = 'grabbing';
      el.style.userSelect = 'none';
    };

    _this.onPointerMove = function (e) {
      if (!_this.isDown) return;
      e.preventDefault();
      var el = _this.slider.current;
      if (!el) return;
      var dx = e.clientX - _this.startX;
      if (Math.abs(dx) > 4) _this.dragMoved = true;
      el.scrollLeft = _this.startScrollLeft - dx;
    };

    _this.endDrag = function (e) {
      var el = _this.slider.current;
      _this.isDown = false;
      if (el) {
        // Restore snap behavior by clearing inline style so CSS applies
        el.style.scrollSnapType = '';
        el.style.cursor = '';
        el.style.userSelect = '';
      }
      if (e && e.pointerId && el) {
        try {
          el.releasePointerCapture(e.pointerId);
        } catch (_) {}
      }
    };

    _this.onPointerUp = function (e) {
      return _this.endDrag(e);
    };

    _this.onPointerCancel = function (e) {
      return _this.endDrag(e);
    };

    _this.onClickCapture = function (e) {
      if (_this.dragMoved) {
        e.preventDefault();
        e.stopPropagation();
        if (e.nativeEvent && typeof e.nativeEvent.stopImmediatePropagation === 'function') {
          e.nativeEvent.stopImmediatePropagation();
        }
        _this.dragMoved = false;
      }
    };

    _this.slider = _react2.default.createRef();

    _this.isDown = false;
    _this.dragMoved = false;
    _this.startX = 0;
    _this.startScrollLeft = 0;
    return _this;
  }

  _createClass(SmoothDragScroll, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          rootclassName = _props.rootclassName,
          style = _props.style,
          rest = _objectWithoutProperties(_props, ['children', 'className', 'rootclassName', 'style']);
      // Match original DragScroll behavior: 'h-scroll-wrapper' plus any provided classes


      var classes = ['h-scroll-wrapper'];
      if (rootclassName) classes.push(rootclassName);
      if (className) classes.push(className);

      var mergedStyle = _extends({ touchAction: 'pan-x' }, style);

      return _react2.default.createElement(
        'div',
        _extends({
          ref: this.slider,
          className: classes.join(' '),
          style: mergedStyle,
          onPointerDown: this.onPointerDown,
          onPointerMove: this.onPointerMove,
          onPointerUp: this.onPointerUp,
          onPointerCancel: this.onPointerCancel,
          onDragStart: function onDragStart(e) {
            e.preventDefault();
          },
          onClickCapture: this.onClickCapture
        }, rest),
        children
      );
    }
  }]);

  return SmoothDragScroll;
}(_react2.default.Component);

SmoothDragScroll.propTypes = {
  className: _propTypes2.default.string,
  rootclassName: _propTypes2.default.string,
  style: _propTypes2.default.object,
  children: _propTypes2.default.node
};

exports.default = SmoothDragScroll;

/***/ }),

/***/ 647:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/site/landing-pages/IndustrySystemv2.jsx.15b089e2.js